<template>

	<!-- Page header -->
	<div class="page-header page-header-light shadow">

		<!-- breadcrumb -->
		<div class="page-header-content d-lg-flex">
			<div class="d-flex">
				<h4 class="page-title mb-0">
					<router-link href="#" class="mb-xs-1 text-dark cursor-pointer" :to="'Dashboard'"><i class="icon-arrow-left52 me-1"></i></router-link>
					<a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer" @click.prevent="getProgetti()"> Progetti </a>
					<span class="hidden-xs ms-1">\</span>
					<span class="text-muted ms-1"><Translate :path="'dizionario.base.ELENCO'"></Translate> Progetti</span>
				</h4>
				<a href="#page_header" class="hidden-lg btn btn-light align-self-center collapsed border-transparent rounded-pill p-0 ms-auto" data-bs-toggle="collapse">
					<i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
				</a>
			</div>
			<div class="collapse d-lg-block my-lg-auto ms-lg-auto text-center" id="page_header">
				<div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">

					<a href="#" class="d-inline-flex align-items-center text-body lh-1 py-sm-2 position-10" style="text-align: left;" v-if="$root.hasFunzionalita('PROGETTO_CREATE')" v-on:click="nuovoProgetto()">
						<i class="ph-plus fw-bold me-2 btn btn-outline-success w-32px h-32px rounded-pill"></i>
						<div class="me-auto me-lg-1 ms-1">
							<div class="text-success fw-semibold mb-1"><Translate :path="'dizionario.base.BTN_ADD'"></Translate></div>
							<div class="fs-sm text-muted mb-0">
								<Translate :path="'dizionario.base.BTN_NUOVO'" class="me-1"></Translate>
								<Translate :path="'dizionario.progetti.PROGETTO'"></Translate>
							</div>
						</div>
					</a>

					<div class="vr flex-shrink-0 my-2 mx-3"></div>

					<div class="d-inline-flex float-end mt-sm-0">
						<a v-if="$root.hasFunzionalita('CONF_PROGETTI_READ')" href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill" v-on:click="$root.confTravelTipologiche(11)" title="Opzioni Progetti" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="ph-lightning"></i>
						</a>
						<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill ms-2" @click.prevent="$root.confTravelLingue(58)" title="Definizioni Lingua" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="ph-flag"></i>
						</a>
						<a href="#" class="btn btn-outline-pink btn-icon w-32px h-32px squared-pill ms-2" @click.prevent="$root.help(58)" title="Help OnLine" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="icon-question7 pink"></i>
						</a>
					</div>
				</div>
			</div>
		</div>
		<!-- /breadcrumb -->

		<!-- Profile navigation -->
		<div class="navbar navbar-expand-lg border-top py-1">
			<div class="container-fluid">
				<ul class="nav navbar-nav flex-row flex-fill" role="tablist">
					<li class="nav-item me-1" role="presentation">
						<a href="#" class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded" :class="viewMode == 'table' ? 'active' : ''" v-on:click="viewMode = 'table'">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-list"></i>
								<span class="hidden-lg ms-1"><Translate :path="'dizionario.progetti.TABELLA'"></Translate></span>
								<span class="hidden-xs ms-1">
									<Translate :path="'dizionario.base.ELENCO'" class="me-1"></Translate><Translate :path="'dizionario.progetti.PROGETTI'"></Translate>
								</span>
							</div>
						</a>
					</li>
					<li class="nav-item me-1" role="presentation">
						<a href="#" class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded" :class="viewMode == 'kanban' ? 'active' : ''" v-on:click="viewMode = 'kanban'">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-kanban"></i>
								<span class="hidden-lg ms-1"><Translate :path="'dizionario.progetti.KANBAN'"></Translate></span>
								<span class="hidden-xs ms-1"><Translate :path="'dizionario.progetti.KANBAN_PROGETTI'"></Translate></span>
							</div>
						</a>
					</li>
					<li class="nav-item d-lg-none ms-auto">
						<a href="#profile_nav" class="navbar-nav-link navbar-nav-link-icon rounded-pill rounded-pill-small collapsed" data-bs-toggle="collapse" aria-expanded="false">
							<i class="ph-caret-down collapsible-indicator"></i>
						</a>
					</li>
				</ul>

				<div class="navbar-collapse collapse" id="profile_nav">
					<ul class="navbar-nav ms-lg-auto mt-2 mt-lg-0 select-small">
						<li class="nav-item dropdown ms-lg-1 d-flex align-items-center">
							<template v-if="canEditProgetto">
								<span v-if="lockOrdine && !lockOrdine.MIO" class="badge bg-warning text-dark me-2"><i class="ph-lock me-1"></i>{{ viewMode == 'kanban' ? 'Spostamento' : 'Ordinamento' }} in corso da {{ lockOrdine.USERNAME }}</span>
								<a v-if="!lockOrdineHandle" href="#" class="btn btn-flat-indigo border-transparent btn-sm me-3" @click.prevent="attivaOrdine()"><i class="ph-arrows-down-up me-1"></i><span style="font-size:0.8rem;">{{ viewMode == 'kanban' ? 'Sposta' : 'Ordina' }}</span></a>
								<a v-else href="#" class="btn btn-flat-success border-transparent btn-sm me-3" @click.prevent="disattivaOrdine()"><i class="ph-check me-1"></i><span style="font-size:0.8rem;">{{ viewMode == 'kanban' ? 'Fine spostamento' : 'Fine ordinamento' }}</span></a>
							</template>
							<div class="btn-group">
								<a href="#" class="btn btn-flat-indigo border-transparent btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
									<i class="ph-gear me-1"></i>
									<span style="font-size:0.8rem;"><Translate :path="'dizionario.base.AZIONI_MULTIPLE'"></Translate></span>
								</a>
								<div class="dropdown-menu dropdown-menu-end">
									<div class="dropdown-submenu dropdown-submenu-start" v-if="canEditProgetto">
										<a href="#" class="dropdown-item">
											<i class="far fa-ballot-check fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.STATO'"></Translate>
										</a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item" @click.prevent="attivaSelezionati()"><i class="far fa-check-square fa-fw me-2"></i><Translate :path="'dizionario.base.ATTIVA_SELEZIONATI'"></Translate></a>
											<a href="#" class="dropdown-item" @click.prevent="disattivaSelezionati()"><i class="far fa-square fa-fw me-2"></i><Translate :path="'dizionario.base.DISATTIVA_SELEZIONATI'"></Translate></a>
										</div>
									</div>
									<div class="dropdown-submenu dropdown-submenu-start">
										<a href="#" class="dropdown-item">
											<i class="far fa-file-export fa-fw me-2"></i>
											<span class="text-muted me-1">|</span><Translate :path="'dizionario.base.COMUNICAZIONI'"></Translate>
										</a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item"><i class="far fa-file-excel fa-fw me-2"></i><Translate :path="'dizionario.base.INVIA_EMAIL'"></Translate></a>
											<a href="#" class="dropdown-item"><i class="far fa-file-excel fa-fw me-2"></i><Translate :path="'dizionario.base.INVIA_SMS'"></Translate></a>
										</div>
									</div>
									<!-- <div class="dropdown-submenu dropdown-submenu-start">
										<a href="#" class="dropdown-item"><i class="far fa-file-export fa-fw me-2"></i><span
												class="text-muted me-1">|</span>Stampe</a>
										<div class="dropdown-menu">
											<a v-on:click="esportaBudgetPdf()" class="dropdown-item"><i
													class="far fa-file-pdf fa-fw me-2"></i><span
													class="text-muted me-1">|</span>Stampa Budget</a>
										</div>
									</div> -->
									<div class="dropdown-submenu dropdown-submenu-start" v-if="canExportProgetto">
										<a href="#" class="dropdown-item">
											<i class="far fa-file-export fa-fw me-2"></i>
											<span class="text-muted me-1">|</span><Translate :path="'dizionario.base.ESPORTA_DATI'"></Translate>
										</a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('pagina')">
												<i class="far fa-file-export fa-fw me-2"></i><Translate :path="'dizionario.progetti.PAGINA_CORRENTE'"></Translate>
											</a>
											<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('selezionati')">
												<i class="far fa-file-export fa-fw me-2"></i><Translate :path="'dizionario.progetti.PROGETTI_SELEZIONATI'"></Translate>
											</a>
											<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('tutti')">
												<i class="far fa-file-export fa-fw me-2"></i><Translate :path="'dizionario.progetti.TUTTI_PROGETTI'"></Translate>
											</a>
										</div>
									</div>
									<div class="dropdown-divider"></div>
									<a href="#" class="dropdown-item" v-if="canDeleteProgetto" @click.prevent="eliminaSelezionati()">
										<i class="far fa-trash fa-fw me-2 text-danger"></i>
										<span class="text-muted me-1">|</span><Translate :path="'dizionario.base.ELIMINA_SELEZIONATI'"></Translate>
									</a>
									<a href="#" class="dropdown-item" v-if="$root.isGod && arrayProgetti.some(p => p.SELEZIONATO == 1 && p.FLG_ELIMINATO == 1)" @click.prevent="ripristinaSelezionati()">
										<i class="fad fa-redo fa-fw me-2 text-success"></i>
										<span class="text-muted me-1">|</span>Ripristina selezionati
									</a>
								</div>
							</div>
						</li>
						<li class="nav-item">

						</li>
					</ul>
				</div>
			</div>
		</div>
		<!-- /profile navigation -->

	</div>
	<!-- /page header -->

	<!-- Content area -->
	<div class="content content-1 table-cms-wrapper">
		<div class="tab-content flex-1 order-2 order-lg-1">

			<div class="tab-pane fade active show" id="progetti-a">
				<div class="card shadow mb-xs-3 mb-lg-0">
					<div class="card-header d-lg-none p-1">
						<div class="d-grid gap-2">
							<a href="#collapse-all" class="btn btn-flat-info btn-sm collapsed" data-bs-toggle="collapse"
								role="button" aria-expanded="false">
								<Translate :path="'dizionario.base.MOSTRA_FILTRI'"></Translate>
							</a>
						</div>
					</div>
					<div class="collapse" :class="{ show: !$root.isMobile }" id="collapse-all" style="">
						<div class="card-body pb-0">
							<div class="alert alert-2 alert-secondary border-0">
								<form autocomplete="off" action="#" id="progetto-a">
									<div class="row">
										<div class="col-7 col-md-1 col-lg-1 mbx-1">
											<input autocomplete="off" class="form-control form-control-sm" type="text"
												:placeholder="$root.translate('dizionario.progetti.PH_COD_PROGETTO')" :tabindex="3" v-model="search.CODICE_PROGETTO.VALUE" />
										</div>
										<div class="col-12 col-md-5 col-lg-5">
											<div class="row">
												<div class="col-12 col-md-4 mbx-1" :class="$root.isGod ? 'col-md-1' : 'col-md-2'">
													<input autocomplete="off" class="form-control form-control-sm" type="text" :placeholder="$root.translate('dizionario.base.TITOLO')" :tabindex="4" v-model="search.TITOLO.VALUE" />
												</div>
												<div class="col-12 col-md-4 col-lg-4 mbx-1">
													<input autocomplete="off" class="form-control form-control-sm" type="text"
														:placeholder="$root.translate('dizionario.base.CLIENTE')" :tabindex="4" v-model="search.CLIENTE.VALUE" />
												</div>
												<div class="col-12 col-md-4 mbx-1">
													<Select2 v-model="search.FORNITORE.VALUE" :api="'theb-s2/fornitori'" :apiselected="'theb-s2/fornitori/selected'"
														load-on-open :placeholder="$root.translate('dizionario.base.FORNITORE')"></Select2>
												</div>
											</div>
										</div>
										<div class="col-12 col-md-3">
											<div class="row">
												<div class="col-md-6 mbx-1">
													<Select2Locale v-model="search.ACCOUNT.VALUE"
														:placeholder="$root.translate('dizionario.progetti.PH_ACCOUNT')" :options="optionsAmministratoriFiltro" />
												</div>
												<div class="col-md-6 mbx-1">
													<Select2Locale v-model="search.LISTE.VALUE"
														:placeholder="$root.translate('dizionario.progetti.LISTE')" :options="optionsListeFiltro" :solo-attivi="true" />
												</div>
											</div>
										</div>
										<div class="col-12 col-md-3">
											<div class="row">
												<div class="col-md-3 mbx-1">
													<select class="form-select form-select-sm changeyear" id="comboAnno"
														@change="search.PAGINATION.PAGE_NUMBER = 1; getProgetti()" v-model="search.ANNO.VALUE"
														:tabindex="4">
														<option value="">{{ $root.translate('dizionario.base.ANNO') }}</option>
														<option v-for="anno in filters.getAnniOrdine()" v-bind:value="anno.ID" v-bind:key="anno.ID"> {{ anno.DESCRIZIONE }}</option>
													</select>
												</div>
												<div class="col-md-4 mbx-1">
													<select class="form-select form-select-sm" :data-placeholder="$root.translate('dizionario.base.STATO')"
														:tabindex="4" v-model="search.FK_ID_STATO.VALUE">
														<option value="">{{ $root.translate('dizionario.base.STATO') }} </option>
														<option v-for="stato in filters.getOpzioniTipologiche(58)" :key="stato.CUSTOM_1" v-bind:value="stato.CUSTOM_1">{{ stato.DESCRIZIONE }}</option>
													</select>
												</div>
												<div class="col-md-4 mbx-1">
													<select class="form-select form-select-sm" v-model="search.FLG_ATTIVO.VALUE">
														<option value="">{{ $root.translate('dizionario.base.TUTTI') }}</option>
														<option value="1">{{ $root.translate('dizionario.progetti.ATTIVI') }}</option>
														<option value="0">{{ $root.translate('dizionario.progetti.DISATTIVATI') }}</option>
													</select>
												</div>
												<div class="col-md-1 mbx-1 ps-0">
					                                <a href="#collapse-a" class="btn btn-flat-info btn-sm w-100 collapsed" data-bs-toggle="collapse" @click.prevent="filters.resizeGrid('collapse-a','tableFixHead','box-card')" role="button" aria-expanded="false">
					                                    <div v-if="$root.isGod">S</div>
														<div v-else>&nbsp;</div>
													</a>
												</div>
											</div>
										</div>
									</div>
									<div class="collapse" id="collapse-a" v-if="$root.isGod">
										<div class="row">
											<div class="col-5 col-md-1 mt-1">
												<input autocomplete="off" class="form-control form-control-sm" type="text"
													:placeholder="$root.translate('dizionario.progetti.PH_ID_PROGETTO')" :tabindex="1"
													v-model="search.ID_PROGETTO.VALUE" />
											</div>
											<div class="col-12 col-md-2 mt-1">
												<select class="form-select form-select-sm" v-model="search.FLG_ELIMINATO.VALUE">
													<option value="0">{{ $root.translate('dizionario.progetti.NON_ELIMINATI') }}</option>
													<option value="">{{ $root.translate('dizionario.base.TUTTI') }}</option>
													<option value="1">{{ $root.translate('dizionario.progetti.ELIMINATI') }}</option>
												</select>
											</div>

										</div>
									</div>
								</form>
							</div>
						</div>
					</div>

					 <div class="card-body box-card mt-0 mb-0" id="box-card" v-if="viewMode == 'table'">
						<div class="div_table_resp tableFixHead" id="tableFixHead" style="min-height: calc(100vh - 372px);">
		               		<table class="table table-bordered table-hover table-striped table-togglable table-width"> 
			                    <thead class="sticky-top">
									<tr class="bg-secondary text-white">
										<th class="hidden-xs table-head-sm" style="width:2%;">
											<input id="chkAllProgetti" v-on:click="filters.selectAll('chkAllProgetti', paginatedList.arr)" type="checkbox" class=""> 
										</th>
										<th v-show="ordineAttivo" class="table-head-sm text-center" style="width:2%;">
											<i class="ph-dots-six-vertical"></i> 
										</th>
										<th class="table-head-sm" style="width:6%;">
											#<span class="float-end"><Translate :path="'dizionario.progetti.ORD'"></Translate></span>
											<br>&nbsp;
										</th>
										<th class="table-head-sm text-center" style="width:4%;" v-if="$root.isGod"> 
											<Translate :path="'dizionario.progetti.IMG'"></Translate>
											<br>&nbsp;
										</th>
										<th class="table-head-sm" style="width:34%;">
											<Translate :path="'dizionario.progetti.NOME_EVENTO_CODICE'"></Translate><ISort class="float-end" v-model="ordinamento" :campo="'TITOLO'"></ISort>
											<br>&nbsp;
										</th>
										<th class="table-head-sm" style="width:16%;"> 
											<Translate :path="'dizionario.base.CLIENTE'"></Translate><ISort class="float-end" v-model="ordinamento" :campo="'CLIENTE'"></ISort>
											<br>&nbsp;
										</th>
										<th class="table-head-sm" style="width:10%;"> 
											Budget
											<br>&nbsp;
										</th>
										<th class="table-head-sm" style="width:10%;"> 
											Team Leader <ISort class="float-end" v-model="ordinamento" :campo="'ACCOUNT'"></ISort>
											<br><Translate :path="'dizionario.progetti.TEAMS'"></Translate>
										</th>
										<th class="table-head-sm text-center" style="width:7%;"> 
											<Translate :path="'dizionario.base.STATO'"></Translate><ISort class="float-end" v-model="ordinamento" :campo="'FK_ID_STATO'"></ISort>
											<br>&nbsp;
										</th>
										<th v-if="$root.isGod" class="table-head-sm text-center" style="width:4%;"> 
											<Translate :path="'dizionario.base.ATTIVO'"></Translate>
											<br>&nbsp;
										</th>
										<th class="table-head-sm text-center" style="width:5%;"> 
											<Translate :path="'dizionario.base.AZIONI'"></Translate>
											<br>&nbsp;
										</th>
									</tr>
								</thead>
								<draggable tag="tbody" :list="paginatedList.arr" handle=".handle" @end="ordineChangeHandler" :animation="200">
									<tr v-for="progetto in paginatedList.arr" v-bind:key="progetto.ID_PROGETTO" :class="{ 'table-danger text-muted': progetto.FLG_ELIMINATO == 1 }">
										<td class="hidden-xs td-class text-center">
											<span class="footable-toggle"></span>
											<input type="checkbox" v-bind:true-value="1" v-bind:false-value="0" v-model="progetto.SELEZIONATO" class="">
										</td>
										<td v-show="ordineAttivo" class="td-class text-center" :class="{ 'cursor-pointer': ordineAttivo }">
											<i class="ph-dots-six-vertical text-muted handle"></i>
										</td>
										<td class="td-class fs-sm">
											<span>{{ progetto.ID_PROGETTO }}</span><br />
											<small class="badge bg-light badge-xs text-primary float-end">{{ progetto.ORDINE }}</small>
										</td>
										<td class="td-class text-center" v-if="$root.isGod">
											<img v-if="progetto.ID_PROGETTO > 0 && progetto.URL_AVATAR != 'placeholder.jpg'" :src="filters.getImgPath('PROGETTI',progetto.URL_AVATAR)" class="img-fluid squared-circle rounded-0" alt="" width="215" style="max-height: 230px;" />
											<span v-if="progetto.ID_PROGETTO == 0 || progetto.URL_AVATAR == 'placeholder.jpg'" class="btn-nophoto squared fs-sm" style="width: 50px; height: 40px !important; line-height: 10px; padding-top: 8px; font-size: 0.6rem !important;">
												No<br data-v-007d6c61="">Photo
											</span>
											<div class="card-img-actions-overlay card-img rounded-circle">
												<a href="#" class="btn btn-outline-white btn-icon rounded-pill" v-on:click="uploadImmagineProgetto(progetto)">
													<i class="ph-pencil"></i>
												</a>
											</div>
										</td>
										<td class="td-class fs-sm">
											<span v-if="progetto.CODICE_PROGETTO" class="badge bg-purple badge-xs text-white me-0" style="margin-bottom: 0.48rem;">
												<i class="far fa-hashtag fa-fw"></i> {{ progetto.CODICE_PROGETTO }}
											</span> - 
											<span class="text-primary text-uppercase fw-bold cursor-pointer text-truncate" v-on:click="openOffCanvas(); openSchedaVisualizzazioneProgetto(progetto)">
												{{ filters.accorciaTesto(progetto.TITOLO,45) }}
											</span>
											<span @click="apriToDo(progetto)" class="cursor-pointer"><i class="fas fa-tasks fa-fw float-end" style="margin-top: 5px;" :class="{'text-success' : progetto.HAS_TASKS == 1, 'text-dark' : progetto.HAS_TASKS == 0}"></i></span>
											<br />
											<!--
											<span v-if="progetto.DATA_SETUP && !String(progetto.DATA_SETUP).startsWith('1900')" class="badge bg-white badge-xs text-dark me-2" style="border: 1px #dddddd solid;" title="Allestimento">
												<i class="far fa-tools fa-fw"></i> {{ filters.formatDate(progetto.DATA_SETUP) }}
											</span>
											-->
											<span class="badge bg-white bg-opacity-20 text-info badge-xs text-dark me-2" style="border: 1px #dddddd solid;" title="Data Evento">
												<i class="far fa-calendar fa-fw"></i> {{ filters.formatPeriodo(progetto.DATA_INIZIO_EVENTO, progetto.DATA_FINE_EVENTO) }}
											</span>
											<span class="badge bg-white badge-xs text-dark me-2" style="border: 1px #dddddd solid; cursor: pointer;" @click="apriNuovaRevisioneProgetto(progetto)" title="Crea nuova revisione">
												<i class="fas fa-code-branch fa-fw"></i> {{ progetto.PROGRESSIVO_REVISIONE_CORRENTE ? 'Rev. ' + progetto.PROGRESSIVO_REVISIONE_CORRENTE : '+ Rev' }}
											</span>
											<span v-for="lista in progetto.LISTE.filter(l => l.FK_ID_TIPOLOGICA == TIPOLOGICA_POSIZIONI)" :key="'c'+lista.ID_LISTA"
												class="badge bg-white badge-xs text-dark me-2" style="border: 1px #dddddd solid;">
												<i class="fas fa-map-marker-alt fa-fw text-danger"></i> {{ lista.DESCRIZIONE }}
											</span>
											<span v-for="lista in progetto.LISTE.filter(l => l.FK_ID_TIPOLOGICA != TIPOLOGICA_POSIZIONI)" :key="lista.ID_LISTA" class="badge bg-white bg-opacity-20 text-info badge-xs me-2" style="border: 1px #dddddd solid;">
												<i class="fas fa-tag fa-fw"></i> <span class="text-dark" href="#">{{ lista.DESCRIZIONE }}</span>
											</span>
											<span v-show="progetto.NOTE != ''" class="badge bg-white bg-opacity-20 badge-xs text-info cursor-pointer" style="border: 1px #dddddd solid;" @click="apriPopUpNote(progetto)">
												<i class="fas fa-info-circle fa-fw text-danger"></i>
											</span>
										</td>
										<td class="td-class fs-sm align-top">
											<span class="text-secondary text-uppercase fw-bold">{{ progetto.CLIENTE }}</span>
											<i v-if="progetto.NUM_MODALITA_PAGAMENTO_ATTIVE > 0 || progetto.NUM_MODALITA_PAGAMENTO_DISATTIVE > 0" class="fad fa-credit-card fa-fw float-end text-warning me-1" style="margin-top: 5px;" data-bs-toggle="tooltip" data-bs-placement="top" :title="titoloModalitaPagamento(progetto)"></i>
											<br />
											<span class="badge bg-white badge-xs text-dark rounded-0 me-1 mt-1" style="border: 1px #dddddd solid;" data-bs-toggle="tooltip" data-bs-placement="top" :title="progetto.EMAIL" v-bind:href="`mailto:${progetto.EMAIL}`">
												<i class="fal fa-envelope fa-fw"></i> Email
											</span>
											<span class="badge bg-white badge-xs text-dark rounded-0 me-1 mt-1" style="border: 1px #dddddd solid;" data-bs-toggle="tooltip" data-bs-placement="top" :title="progetto.TELEFONO" v-bind:href="`tel:${progetto.TELEFONO}`">
												<i class="fal fa-phone fa-fw"></i> Tel.
											</span>
										</td>
										<td class="td-class fs-sm">
											<div>
												<span>Imponibile:</span>
												<a class="text-teal float-end" href="#">&euro; {{ filters.formattaImporto(progetto.TOTALE_FINALE) }}</a>
											</div>

											<div>
												<span>Costi:</span>
												<a class="text-danger float-end" href="#">&euro; {{ filters.formattaImporto(progetto.TOTALI.ACQUISTO) }}</a>
											</div>
										</td>
										<td class="td-class fs-sm">
											<!--<span style="font-size: 11px; text-transform: uppercase; color: rgb(113, 128, 150); font-weight: 700; margin-bottom: 6px; display: block; letter-spacing: 0.5px;">{{ progetto.ACCOUNT }}</span>-->
											<div class="d-flex align-items-center">
											<a v-if="progetto.ACCOUNT_USERNAME" href="javascript:void(0)" class="avatar-group-item avatar-am" data-bs-toggle="tooltip" data-bs-placement="top" :title="'Account Manager: ' + progetto.ACCOUNT_USERNAME">
												<img v-if="progetto.ACCOUNT_AVATAR && progetto.ACCOUNT_AVATAR != 'placeholder.jpg'"
													:src="filters.getImgPath('USERS', progetto.ACCOUNT_AVATAR)" alt="avatar" class="rounded-circle avatar-xxs">
												<div v-else class="avatar-xxs rounded-circle bg-light d-flex align-items-center justify-content-center">
													<i class="fa fa-user-crown text-secondary" style="font-size:0.8rem"></i>
												</div>
											</a>
											<span v-if="progetto.ACCOUNT_USERNAME && utentiCondivisi(progetto).length" class="border-start mx-1 flex-shrink-0" style="height:1.25rem"></span>
											<div class="avatar-group mt-0" v-if="utentiCondivisi(progetto).length">
												<a v-for="utente in utentiCondivisi(progetto).slice(0, 4)"
													:key="utente.ID_UTENTE"
													href="javascript:void(0)"
													class="avatar-group-item"
													data-bs-toggle="tooltip"
													data-bs-placement="top"
													:title="utente.USERNAME">
													<img v-if="utente.ID_UTENTE > 0 && utente.URL_AVATAR != 'placeholder.jpg'"
														:src="filters.getImgPath('USERS', utente.URL_AVATAR)" alt="avatar" class="rounded-circle avatar-xxs">
													<div v-else class="avatar-xxs rounded-circle bg-light d-flex align-items-center justify-content-center">
														<i class="fa fa-user text-secondary" style="font-size:0.65rem"></i>
													</div>
												</a>
												<a v-if="utentiCondivisi(progetto).length > 4"
													href="javascript:void(0)"
													class="avatar-group-item"
													@click="apriPopupUtenti(progetto)">
													<div class="avatar-xxs rounded-circle bg-dark d-flex align-items-center justify-content-center"
														style="font-size:0.6rem; color:#fff; font-weight:bold; cursor:pointer;">
														+{{ utentiCondivisi(progetto).length - 4 }}
													</div>
												</a>
											</div>
											</div>
										</td>
										<td class="td-class fs-sm text-center">
											<span class="badge badge-xs" :style="{ backgroundColor: getStatoColore(progetto.FK_ID_STATO) }">
												{{ getStatoDescrizione(progetto.FK_ID_STATO) }}
											</span>
										</td>
										<td v-if="$root.isGod" class="td-class text-center">
											<ISwitch :size="'xs'" :modelValue="progetto.FLG_ATTIVO" @toggle="(val) => toggleFlgAttivoProgetto(progetto, val)" title="Attivo/Disattivo"></ISwitch>
										</td>
										<td class="td-class text-center">
											<div class="dropdown">
												<a href="#" class="text-body" data-bs-toggle="dropdown" data-bs-popper-config='{"strategy":"fixed"}' aria-expanded="false"><i class="ph-list"></i></a>
												<div class="dropdown-menu dropdown-menu-end">
													<div class="dropdown-header text-uppercase font-size-xs line-height-xs"> <Translate :path="'dizionario.progetti.GESTIONE'"></Translate></div>
													<a href="#" class="dropdown-item" v-if="canEditProgetto" v-on:click="modificaProgetto(progetto)">
														<i class="fad fa-pencil fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.progetti.MODIFICA_PROGETTO'"></Translate>
													</a>
													<a href="#" class="dropdown-item" v-if="canCreateProgetto" v-on:click="apriDuplicaProgetto(progetto)">
														<i class="fad fa-copy fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.progetti.DUPLICA_PROGETTO'"></Translate>
													</a>
													<div class="dropdown-divider"></div>
													<a href="#" class="dropdown-item" v-on:click="gestisciAttivita(progetto)">
														<i class="fad fa-file-invoice-dollar fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.progetti.GESTIONE_BUDGET'"></Translate>
													</a>
													<a href="#" class="dropdown-item" @click.prevent="progettoAllegati = progetto">
														<i class="fas fa-paperclip fa-fw me-2"></i><span class="text-muted me-1">|</span>Allegati
													</a>
													<div class="dropdown-submenu dropdown-submenu-start" v-if="canExportProgetto">
														<a href="#" class="dropdown-item"><i class="fad fa-print fa-fw me-2"></i><span class="text-muted me-1">|</span>Stampe</a>
														<div class="dropdown-menu">
															<a href="#" class="dropdown-item" @click.prevent="apriModalitaEsportazione(progetto)"><i class="far fa-file-excel fa-fw me-2"></i><span class="text-muted me-1">|</span>Esporta Excel</a>
															<a href="#" class="dropdown-item" @click.prevent="esportaBudgetPdf(progetto)"><i class="far fa-file-pdf fa-fw me-2"></i><span class="text-muted me-1">|</span>Stampa Budget</a>
														</div>
													</div>
													<div class="dropdown-divider"></div>
													<div class="dropdown-header text-uppercase font-size-xs line-height-xs"> <Translate :path="'dizionario.progetti.ADMIN'"></Translate></div>
													<a href="#" class="dropdown-item" v-on:click="storicoProgetto(progetto)">
														<i class="fad fa-list fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.progetti.STORICO_PROGETTO'"></Translate>
													</a>
													<a href="#" class="dropdown-item" v-if="progetto.FLG_ELIMINATO != 1 && canDeleteProgetto" v-on:click="eliminaProgetto(progetto)">
														<i class="fad fa-trash fa-fw text-danger me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.progetti.ELIMINA_PROGETTO'"></Translate>
													</a>
													<a href="#" class="dropdown-item" v-if="$root.isGod && progetto.FLG_ELIMINATO == 1" v-on:click="eliminaDefinitivamenteProgetto(progetto)">
														<i class="fad fa-trash-alt fa-fw text-danger me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_ELIMINA_DEF'"></Translate>
													</a>
													<a href="#" class="dropdown-item text-success" v-if="$root.isGod && progetto.FLG_ELIMINATO == 1" v-on:click="ripristinaProgetto(progetto)">
														<i class="fad fa-redo fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_RIPRISTINA'"></Translate>
													</a>
												</div>
											</div>
										</td>
									</tr>
								</draggable>
							</table>
						</div>

						<div class="row page-bottom">
							<div class="col-12 col-md-8 d-none d-sm-block" :tabindex="27">
								<div style="position: relative; top: 10px;">
									<!--<span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2 me-2">
										<Translate :path="'dizionario.progetti.TOTALE_PARZIALE'"></Translate>: &euro; {{ filters.formattaImporto(getTotali.BUDGET) }}
									</span>
									<span class="badge bg-info bg-opacity-20 text-info rounded-0 p-2 me-2">
										<Translate :path="'dizionario.progetti.FEE_AGENZIA'"></Translate>: &euro; {{ filters.formattaImporto(getTotali.FEE) }}
									</span>-->
									<span class="badge bg-primary bg-opacity-20 text-primary rounded-0 p-2 me-2" style="font-weight: bold;">
										<Translate :path="'dizionario.attivita.TOTALE_FINALE'"></Translate>: &euro; {{ filters.formattaImporto(getTotali.GRAND_TOTAL) }}
									</span>
									<span class="badge bg-danger bg-opacity-20 text-danger rounded-0 p-2 me-2">
										<Translate :path="'dizionario.progetti.COSTI_ESP'"></Translate>: &euro; {{ filters.formattaImporto(getTotali.COSTO_ESPOSTO) }}
									</span>
									<!--<span class="badge bg-warning bg-opacity-20 text-warning rounded-0 p-2 me-2">
										<Translate :path="'dizionario.progetti.COSTI_PRIV'"></Translate>: &euro; {{ filters.formattaImporto(getTotali.COSTO_PRIVATO) }}
									</span>-->
									<span class="badge bg-success bg-opacity-20 text-success rounded-0 p-2 me-2">
										<Translate :path="'dizionario.progetti.UTILE'"></Translate>: &euro; {{ filters.formattaImporto(getTotali.MARGINE) }}
									</span>
									<span class="badge bg-success bg-opacity-20 text-success rounded-0 p-2 me-2">
										<Translate :path="'dizionario.progetti.MARGINE'"></Translate>: {{ getMarginePercentage() }}%
									</span>
								</div>
							</div>
							<div class="col-9 col-md-3" :tabindex="27">
								<div class=" float-end pag-mobile">
									<Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count" :numpagine="search.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
								</div>
							</div>
							<div class="col-3 col-md-1" :tabindex="28">
								<select class="form-select form-select-sm wmin-100 mt-2 float-end" data-placeholder="Limite" :tabindex="20" v-model="search.PAGINATION.PAGE_SIZE" style="position: relative; top: 0px; padding: 0.4375rem 0.5rem;">
									<option value="5">5</option>
									<option value="10">10</option>
									<option value="25">25</option>
									<option value="50">50</option>
									<option value="75">75</option>
									<option value="100">100</option>
									<option value="250">250</option>
									<option value="500">500</option>
								</select>
							</div>
						</div>
					</div>

					<!-- Vista Kanban -->
					<div class="card-body p-2" v-else-if="viewMode == 'kanban'">
						<!--
						<div class="d-flex align-items-center mb-2 px-1">
							<input id="chkAllProgettiKanban" type="checkbox" v-on:click="filters.selectAll('chkAllProgettiKanban', paginatedList.arr)" class="me-2">
							<label for="chkAllProgettiKanban" class="fs-sm text-muted mb-0" style="cursor:pointer;">
								<Translate :path="'dizionario.progetti.SELEZIONA_TUTTI'"></Translate>
							</label>
						</div>
						-->
						<div ref="kanbanContainer" class="d-flex gap-2 overflow-auto pb-3 kanban-container" style="min-height: 600px; background-color: #e9f1f5; padding: 0.75rem; border-radius: 0.375rem;">
							<!-- Colonna per ogni stato -->
							<div v-for="stato in filters.getOpzioniTipologiche(58)" :key="stato.CUSTOM_1" class="flex-shrink-0" :style="{ width: kanbanColumnWidth }">
								<div class="card shadow-sm h-100">
									<div class="card-header py-2 text-white" :style="{ backgroundColor: stato.ICONA || '#6c757d' }">
										<h6 class="mb-0 fw-bold">
											{{ stato.DESCRIZIONE }}
											<span class="badge bg-white bg-opacity-25 float-end">
												{{paginatedList.arr.filter(p => p.FK_ID_STATO == stato.CUSTOM_1).length}}
											</span>
										</h6>
									</div>
									<div class="card-body p-2 kanban-col-body" style="overflow-y: auto; max-height: 550px;">
										<draggable tag="div" :list="paginatedList.arr" group="progetti" :disabled="!ordineAttivo"
											:data-stato-id="stato.CUSTOM_1" @start="onKanbanDragStart"
											@end="onKanbanDrop" handle=".kanban-drag-handle" class="kanban-column"
											style="min-height: 100px;">
											<div v-for="progetto in paginatedList.arr.filter(p => p.FK_ID_STATO == stato.CUSTOM_1)"
												:key="progetto.ID_PROGETTO" :data-id="progetto.ID_PROGETTO"
												class="card mb-2 shadow-sm" :class="{ 'bg-danger bg-opacity-10': progetto.FLG_ELIMINATO == 1 }">
												<div class="card-body p-2">
													<!-- Immagine progetto -->
													<div class="text-center mb-2"
														v-if="progetto.URL_AVATAR && progetto.URL_AVATAR != 'placeholder.jpg'">
														<img :src="filters.getImgPath('PROGETTI', progetto.URL_AVATAR)"
															class="rounded w-100"
															style="max-height: 150px; object-fit: cover;" alt="" />
													</div>

													<!-- Titolo e codice con drag handle -->
													<div class="d-flex align-items-start mb-1">
														<!--
														<input type="checkbox"
															v-bind:true-value="1"
															v-bind:false-value="0"
															v-model="progetto.SELEZIONATO"
															class="me-2 mt-1"
															style="flex-shrink:0;" />
														-->
														<i v-show="ordineAttivo" class="fas fa-arrows text-muted kanban-drag-handle me-2"
															style="cursor: grab; flex-shrink: 0;"
															title="Trascina per spostare"></i>
														<h6 class="mb-0 flex-grow-1">
															<a href="#" class="text-dark fw-bold"
																v-on:click="openOffCanvas(); openSchedaVisualizzazioneProgetto(progetto)">
																{{ progetto.TITOLO }}
															</a>
														</h6>
													</div>

													<div class="mb-2 d-flex align-items-center gap-1 flex-wrap">
														<span v-if="progetto.CODICE_PROGETTO" class="badge bg-primary badge-xs">
															<i class="far fa-hashtag"></i> {{ progetto.CODICE_PROGETTO }}
														</span>
														<span class="badge bg-light badge-xs text-dark" style="border: 1px #dddddd solid; cursor: pointer;" @click="apriNuovaRevisioneProgetto(progetto)" title="Crea nuova revisione">
															<i class="fas fa-code-branch fa-fw"></i>
															<template v-if="progetto.PROGRESSIVO_REVISIONE_CORRENTE">
																<Translate :path="'dizionario.progetti.REVISIONE'"></Translate> {{ progetto.PROGRESSIVO_REVISIONE_CORRENTE }}
															</template>
															<template v-else>+ Rev</template>
														</span>
														<span v-for="lista in progetto.LISTE.filter(l => l.FK_ID_TIPOLOGICA == TIPOLOGICA_POSIZIONI)"
															:key="'c'+lista.ID_LISTA"
															class="badge bg-light badge-xs text-dark"
															style="border: 1px #dddddd solid;">
															<i class="fas fa-map-marker-alt fa-fw text-danger"></i> {{ lista.DESCRIZIONE }}
														</span>
														<span class="badge bg-light badge-xs text-primary ms-auto">
															#{{ progetto.ID_PROGETTO }}
														</span>
													</div>

													<!-- Cliente -->
													<div class="mb-1 fs-sm">
														<i class="ph-buildings fs-base text-muted me-1"></i>
														<strong>{{ progetto.CLIENTE }}</strong>
													</div>

													<!-- Contatti cliente -->
													<div class="mb-1 d-flex gap-1 flex-wrap">
														<span v-if="progetto.EMAIL" class="badge bg-light badge-xs text-dark rounded-0"
															style="border: 1px #dddddd solid;" data-bs-toggle="tooltip"
															data-bs-placement="top" :title="progetto.EMAIL"
															:href="`mailto:${progetto.EMAIL}`">
															<i class="fal fa-envelope fa-fw"></i> Email
														</span>
														<span v-if="progetto.TELEFONO" class="badge bg-light badge-xs text-dark rounded-0"
															style="border: 1px #dddddd solid;" data-bs-toggle="tooltip"
															data-bs-placement="top" :title="progetto.TELEFONO"
															:href="`tel:${progetto.TELEFONO}`">
															<i class="fal fa-phone fa-fw"></i> Tel.
														</span>
													</div>

													<!-- Data evento -->
													<div class="mb-1 fs-sm text-muted">
														<i class="ph-calendar fs-base me-1"></i>
														{{ filters.formatPeriodo(progetto.DATA_INIZIO_EVENTO, progetto.DATA_FINE_EVENTO) }}
													</div>
													<div class="mb-1 fs-sm text-muted" v-if="progetto.DATA_SETUP && !String(progetto.DATA_SETUP).startsWith('1900')" title="Allestimento">
														<i class="ph-wrench fs-base me-1"></i>
														{{ filters.formatDate(progetto.DATA_SETUP) }}
													</div>

													<!-- Location -->
													<div class="mb-1 fs-sm text-muted" v-if="progetto.LOCATION">
														<i class="ph-map-pin fs-base me-1"></i>
														{{ progetto.LOCATION }}<span v-if="progetto.CAP">, {{ progetto.CAP }}</span>
													</div>

													<!-- Liste -->
													<div class="mb-1" v-if="progetto.LISTE && progetto.LISTE.some(l => l.FK_ID_TIPOLOGICA != TIPOLOGICA_POSIZIONI)">
														<span v-for="lista in progetto.LISTE.filter(l => l.FK_ID_TIPOLOGICA != TIPOLOGICA_POSIZIONI)" :key="lista.ID_LISTA"
															class="badge bg-secondary bg-opacity-20 text-secondary me-1 mb-1"
															style="font-size: 0.7rem;">
															<i class="fal fa-tag fa-fw"></i> {{ lista.DESCRIZIONE }}
														</span>
													</div>

													<!-- Autore -->
													<div class="mb-1 fs-sm" v-if="progetto.ACCOUNT">
														<i class="ph-user fs-base text-muted me-1"></i>
														<strong><Translate :path="'dizionario.progetti.AUTORE'"></Translate>:</strong> {{ progetto.ACCOUNT }}
													</div>

													<!-- Collaboratori -->
													<div class="mt-2 mb-2 d-none d-sm-flex align-items-center">
													<a v-if="progetto.ACCOUNT_USERNAME" href="javascript:void(0)" class="avatar-group-item avatar-am" data-bs-toggle="tooltip" data-bs-placement="top" :title="'Account Manager: ' + progetto.ACCOUNT_USERNAME">
														<img v-if="progetto.ACCOUNT_AVATAR && progetto.ACCOUNT_AVATAR != 'placeholder.jpg'"
															:src="filters.getImgPath('USERS', progetto.ACCOUNT_AVATAR)" alt="avatar" class="rounded-circle avatar-xxs">
														<div v-else class="avatar-xxs rounded-circle bg-light d-flex align-items-center justify-content-center">
															<i class="fa fa-user-crown text-secondary" style="font-size:0.8rem"></i>
														</div>
													</a>
													<span v-if="progetto.ACCOUNT_USERNAME && utentiCondivisi(progetto).length" class="border-start mx-1 flex-shrink-0" style="height:1.25rem"></span>
													<div class="avatar-group mt-0" v-if="utentiCondivisi(progetto).length">
														<a v-for="utente in utentiCondivisi(progetto).slice(0, 4)"
															:key="utente.ID_UTENTE"
															href="javascript:void(0)"
															class="avatar-group-item"
															data-bs-toggle="tooltip"
															data-bs-placement="top"
															:title="utente.USERNAME">
															<img v-if="utente.ID_UTENTE > 0 && utente.URL_AVATAR != 'placeholder.jpg'"
																:src="filters.getImgPath('USERS', utente.URL_AVATAR)" alt="avatar" class="rounded-circle avatar-xxs">
															<div v-else class="avatar-xxs rounded-circle bg-light d-flex align-items-center justify-content-center">
																<i class="fa fa-user text-secondary" style="font-size:0.65rem"></i>
															</div>
														</a>
														<a v-if="utentiCondivisi(progetto).length > 4"
															href="javascript:void(0)"
															class="avatar-group-item"
															@click="apriPopupUtenti(progetto)">
															<div class="avatar-xxs rounded-circle bg-dark d-flex align-items-center justify-content-center"
																style="font-size:0.6rem; color:#fff; font-weight:bold; cursor:pointer;">
																+{{ utentiCondivisi(progetto).length - 4 }}
															</div>
														</a>
													</div>
													</div>

													<!-- Azioni -->
													<div class="d-flex gap-1 mt-2 justify-content-end">
														<ISwitch v-if="$root.isGod" :size="'xs'" :modelValue="progetto.FLG_ATTIVO" @toggle="(val) => toggleFlgAttivoProgetto(progetto, val)" title="Attivo/Disattivo"></ISwitch>
														<span v-if="progetto.NUM_MODALITA_PAGAMENTO_ATTIVE > 0 || progetto.NUM_MODALITA_PAGAMENTO_DISATTIVE > 0" class="btn-kanban-action text-warning" data-bs-toggle="tooltip" data-bs-placement="top" :title="titoloModalitaPagamento(progetto)">
															<i class="fad fa-credit-card"></i>
														</span>
														<a href="#" class="btn-kanban-action"
															v-on:click="apriToDo(progetto)" title="Task" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Task"
															:class="{'text-success' : progetto.HAS_TASKS == 1, '' : progetto.HAS_TASKS == 0}">
															<i class="fas fa-tasks"></i>
														</a>
														<a href="#" class="btn-kanban-action" v-if="$root.hasFunzionalita('PROGETTO_UPDATE')" v-on:click="modificaProgetto(progetto)" title="Modifica" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Modifica">
															<i class="ph-pencil"></i>
														</a>
														<a href="#" class="btn-kanban-action" v-on:click="gestisciAttivita(progetto)" title="Budget" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Budget">
															<i class="ph-currency-circle-dollar"></i>
														</a>
														<div class="dropdown">
															<a href="#" class="btn-kanban-action" data-bs-toggle="dropdown" data-bs-popper-config='{"strategy":"fixed"}'>
																<i class="ph-dots-three-vertical"></i>
															</a>
															<div class="dropdown-menu dropdown-menu-end">
																<a href="#" class="dropdown-item" @click.prevent="progettoAllegati = progetto">
																	<i class="fas fa-paperclip fa-fw me-2"></i>Allegati
																</a>
																<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('PROGETTO_CREATE')" v-on:click="apriDuplicaProgetto(progetto)">
																	<i class="fad fa-copy fa-fw me-2"></i><Translate :path="'dizionario.progetti.DUPLICA'"></Translate>
																</a>
																<div class="dropdown-submenu dropdown-submenu-start" v-if="canExportProgetto">
																	<a href="#" class="dropdown-item"><i class="fad fa-print fa-fw me-2"></i>Stampe</a>
																	<div class="dropdown-menu">
																		<a href="#" class="dropdown-item" @click.prevent="apriModalitaEsportazione(progetto)"><i class="far fa-file-excel fa-fw me-2"></i>Esporta Excel</a>
																		<a href="#" class="dropdown-item" @click.prevent="esportaBudgetPdf(progetto)"><i class="far fa-file-pdf fa-fw me-2"></i>Stampa Budget</a>
																	</div>
																</div>
																<a href="#" class="dropdown-item" v-on:click="storicoProgetto(progetto)">
																	<i class="fad fa-list fa-fw me-2"></i><Translate :path="'dizionario.progetti.STORICO'"></Translate>
																</a>
																<div class="dropdown-divider"></div>
																<a href="#" class="dropdown-item text-danger" v-if="progetto.FLG_ELIMINATO != 1 && canDeleteProgetto" v-on:click="eliminaProgetto(progetto)">
																	<i class="fad fa-trash fa-fw me-2"></i><Translate :path="'dizionario.base.BTN_ELIMINA'"></Translate>
																</a>
																<a href="#" class="dropdown-item text-danger" v-if="$root.isGod && progetto.FLG_ELIMINATO == 1" v-on:click="eliminaDefinitivamenteProgetto(progetto)">
																	<i class="fad fa-trash-alt fa-fw me-2"></i><Translate :path="'dizionario.base.BTN_ELIMINA_DEF'"></Translate>
																</a>
																<a href="#" class="dropdown-item text-success" v-if="$root.isGod && progetto.FLG_ELIMINATO == 1" v-on:click="ripristinaProgetto(progetto)">
																	<i class="fad fa-redo fa-fw me-2"></i><Translate :path="'dizionario.base.BTN_RIPRISTINA'"></Translate>
																</a>
															</div>
														</div>
													</div>
												</div>
											</div>
										</draggable>
									</div>
								</div>
							</div>
						</div>

						<!-- Totaloni Kanban -->
						<div class="row mt-3">
							<div class="col-12">
								<div class="d-flex flex-wrap gap-2 justify-content-start">
									<span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2">
										<Translate :path="'dizionario.progetti.TOTALE_PARZIALE'"></Translate>: &euro; {{ getTotali.BUDGET }}
									</span>
									<span class="badge bg-info bg-opacity-20 text-info rounded-0 p-2">
										<Translate :path="'dizionario.progetti.FEE_AGENZIA'"></Translate>: &euro; {{ getTotali.FEE }}
									</span>
									<span class="badge bg-primary bg-opacity-20 text-primary rounded-0 p-2" style="font-weight: bold;">
										<Translate :path="'dizionario.progetti.TOTALE_IMPONIBILE'"></Translate>: &euro; {{ getTotali.GRAND_TOTAL }}
									</span>
									<span class="badge bg-danger bg-opacity-20 text-danger rounded-0 p-2">
										<Translate :path="'dizionario.progetti.ACQUISTO'"></Translate>: &euro; {{ getTotali.COSTO_ESPOSTO }}
									</span>
									<span class="badge bg-warning bg-opacity-20 text-warning rounded-0 p-2">
										<Translate :path="'dizionario.progetti.COMMISSIONI'"></Translate>: &euro; {{ getTotali.COSTO_PRIVATO }}
									</span>
									<span class="badge bg-success bg-opacity-20 text-success rounded-0 p-2"
										@click="toggleMarginePercentage()"
										style="cursor: pointer; user-select: none;" title="Clicca per visualizzare percentuale">
										{{ $root.translate(showMarginePercentage ? 'dizionario.progetti.MARGINE' : 'dizionario.progetti.UTILE') }}: <span v-if="!showMarginePercentage">&euro; {{ getTotali.MARGINE }}</span><span v-else>{{ getMarginePercentage() }}%</span>
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>


			<div class="tab-pane fade" id="progetti-b">
				<div class="row">
					<div class="col-sm-6 col-xl-2">
						<div class="card card-body mb-2">
							<div class="d-flex align-items-center">
								<i class="ph-users ph-2x text-primary me-3"></i>
								<div class="flex-fill text-end">
									<h4 class="mb-0"></h4>
									<span class="text-muted">Totale </span>
								</div>
							</div>
						</div>
					</div>
					<div class="col-sm-6 col-xl-2">
						<div class="card card-body mb-2">
							<div class="d-flex align-items-center">
								<i class="ph-thumbs-up ph-2x text-success me-3"></i>

								<div class="flex-fill text-end">
									<h4 class="mb-0"></h4>
									<span class="text-muted">Utenti attivi</span>
								</div>
							</div>
						</div>
					</div>
					<div class="col-sm-6 col-xl-2">
						<div class="card card-body mb-2">
							<div class="d-flex align-items-center">
								<i class="ph-thumbs-down ph-2x text-danger me-3"></i>
								<div class="flex-fill text-end">
									<h4 class="mb-0"></h4>
									<span class="text-muted">Utenti 0 pratiche</span>
								</div>
							</div>
						</div>
					</div>
					<div class="col-sm-6 col-xl-2">
						<div class="card card-body mb-2">
							<div class="d-flex align-items-center">
								<div class="flex-fill">
									<h4 class="mb-0"></h4>
									<span class="text-muted">Utenti bannati</span>
								</div>
								<i class="ph-house-simple ph-2x text-danger ms-3"></i>
							</div>
						</div>
					</div>
					<div class="col-sm-6 col-xl-2">
						<div class="card card-body mb-2">
							<div class="d-flex align-items-center">
								<div class="flex-fill">
									<h4 class="mb-0"> </h4>
									<span class="text-muted">Tot. Fatturato </span>
								</div>
								<i class="ph-sketch-logo ph-2x text-indigo ms-3"></i>
							</div>
						</div>
					</div>
					<div class="col-sm-6 col-xl-2">
						<div class="card card-body mb-2">
							<div class="d-flex align-items-center">
								<div class="flex-fill">
									<h4 class="mb-0"></h4>
									<span class="text-muted">Tot. Fatturato </span>
								</div>
								<i class="ph-globe-hemisphere-east ph-2x text-purple ms-3"></i>
							</div>
						</div>
					</div>
				</div>

				<!-- <Statistiche :modalita="1" :ref="'statistiche'"></Statistiche> -->

			</div>

			<SchedaProgetto 
				:ref="'schedaProgetto'" 
				:statiProgetto="arrayStatiProgetto" 
				@updateGriglia="getProgetti();"
				@updateProgetto="getProgetto">
			</SchedaProgetto>

			<SchedaAttivita 
				:ref="'schedaAttivita'" 
				@updateGriglia="getProgetti();" 
				@updateProgetto="getProgetto">
			</SchedaAttivita>

		</div>
	</div>


	<!-- START MODALI -->
	<div class="offcanvas offcanvas-end offcanvas-size-xlg" id="panel_right" data-bs-backdrop="false" role="dialog" tabindex="-1">
		<div class="offcanvas-header bg-info text-white border-0" style="height: 3.95rem;">
			<h5 class="modal-title modal-title-width">
				<i class="ph-list icon-modal-size me-2"></i>Scheda Informativa
			</h5>
			<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="offcanvas">
				<i class="ph-x icon-x-size"></i>
			</button>
		</div>
		<div class="offcanvas-body p-2">

			<SchedaVisualizzazioneProgetto :ref="'schedaVisualizzazioneProgetto'" @modificaProgetto="modificaProgetto($event)"></SchedaVisualizzazioneProgetto>

		</div>
		<div class="border-top p-1 bg-light">
			<button type="button" class="btn btn-link float-end" data-bs-dismiss="offcanvas">
				<i class="fal fa-sign-out-alt fa-fw me-2"></i>
				<Translate :path="'dizionario.base.BTN_CLOSE'"></Translate>
			</button>
		</div>
	</div>

	<div class="modal fade" :id="'popUpUploadImgProgetto' + rs" role="dialog" tabindex="-1" data-bs-backdrop="static">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h6 class="modal-title"><Translate :path="'dizionario.progetti.UPLOAD_IMMAGINE'"></Translate></h6>
					<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">X</button>
				</div>
				<div class="modal-body">
					<Upload :args="argsProgetto" @onsuccess="successCaricamento($event)"
						@onerror="errorCaricamento($event)"></Upload>
				</div>
				<div class="modal-footer bg-light p-1">
					<button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal"><i
							class="fal fa-sign-out-alt fa-fw"></i> <Translate :path="'dizionario.base.BTN_CLOSE'"></Translate></button>
				</div>
			</div>
		</div>
	</div>

	<div class="modal fade" id="popUpStoricoProgetto" role="dialog" tabindex="-1" data-bs-backdrop="static">
		<div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h6 class="modal-title"><i class="far fa-history fa-fw me-2"></i><Translate :path="'dizionario.progetti.STORICO'"></Translate> — <strong>{{ progettoSelezionato.TITOLO }}</strong></h6>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<div v-if="paginatedListStorico.arr.length == 0" class="text-muted text-center py-4">Nessuna operazione registrata</div>
					<div v-else class="storico-timeline">
						<template v-for="(operazione, index) in paginatedListStorico.arr" v-bind:key="operazione.ID_LOG">
							<div class="storico-giorno" v-if="index == 0 || giornoStorico(operazione) != giornoStorico(paginatedListStorico.arr[index - 1])">
								{{ filters.formatDate(operazione.DATA_AZIONE) }}
							</div>
							<div class="storico-voce">
								<span class="storico-pallino" :class="'bg-' + tipoOperazione(operazione.DESCRIZIONE).colore">
									<i :class="'far fa-fw ' + tipoOperazione(operazione.DESCRIZIONE).icona"></i>
								</span>
								<a href="#" class="storico-riga" @click.prevent="toggleDettaglioStorico(operazione)">
									<span class="fw-semibold flex-grow-1">{{ operazione.DESCRIZIONE }}</span>
									<span class="text-muted fs-sm"><i class="far fa-user fa-fw me-1"></i>{{ operazione.USERNAME }}</span>
									<span class="text-muted fs-sm"><i class="far fa-clock fa-fw me-1"></i>{{ String(operazione.DATA_AZIONE).substring(11, 16) }}</span>
									<i class="far fa-fw text-muted" :class="idLogAperto == operazione.ID_LOG ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
								</a>
								<div class="storico-dettaglio" v-if="idLogAperto == operazione.ID_LOG && dettagliStorico[operazione.ID_LOG]">
									<em class="text-muted" v-if="dettagliStorico[operazione.ID_LOG].righe == null">Dettaglio non disponibile</em>
									<em class="text-muted" v-else-if="dettagliStorico[operazione.ID_LOG].righe.length == 0">Nessuna modifica dettagliata registrata</em>
									<div v-for="(modifica, idx) in dettagliStorico[operazione.ID_LOG].righe" v-bind:key="idx">
										<template v-if="modifica.testo">{{ modifica.testo }}</template>
										<template v-else>
											<strong>{{ modifica.campo }}:</strong>
											<span class="text-danger text-decoration-line-through ms-1">{{ (modifica.rimossi ? modifica.rimossi.join(', ') : modifica.vecchio) || '—' }}</span>
											<i class="far fa-arrow-right fa-fw text-muted mx-1"></i>
											<span class="text-success">{{ (modifica.aggiunti ? modifica.aggiunti.join(', ') : modifica.nuovo) || '—' }}</span>
										</template>
									</div>
								</div>
							</div>
						</template>
					</div>
				</div>
				<div class="modal-footer bg-light p-1">
					<div class="flex-grow-1">
						<Pagine v-model="searchStorico.PAGINATION.PAGE_NUMBER" :numrighe="paginatedListStorico.count" :numpagine="searchStorico.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
					</div>
					<button type="button" class="btn btn-link" data-bs-dismiss="modal"><i class="fal fa-sign-out-alt fa-fw me-1"></i> <Translate :path="'dizionario.base.BTN_CLOSE'"></Translate></button>
				</div>
			</div>
		</div>
	</div>	

	<div class="modal fade" :id="'popUpDuplicaProgetto' + rs" role="dialog" data-bs-backdrop="static">
		<div class="modal-dialog modal-md">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h6 class="modal-title">
						<i class="fad fa-copy me-2"></i>
						<Translate :path="'dizionario.progetti.DUPLICA_PROGETTO'"></Translate>: <strong>{{ duplicaProgettoDati.progettoOrigine?.TITOLO }}</strong>
					</h6>
					<span v-if="duplicaBloccata" class="badge bg-warning text-dark ms-auto me-2"><i class="ph-lock me-1"></i>Duplicazione in corso da {{ lockDuplica.USERNAME }}</span>
					<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill"
						data-bs-dismiss="modal"><i class="ph-x icon-x-size"></i></button>
				</div>
				<div class="modal-body">
					<div class="mb-2">
						<label class="form-label fw-semibold"><Translate :path="'dizionario.progetti.TIPO_CLIENTE'"></Translate> <span class="text-danger">*</span></label>
						<select class="form-select form-select-sm" v-model="duplicaProgettoDati.tipoCliente">
							<option value="">{{ $root.translate('dizionario.base.SELEZIONA') }}</option>
							<option value="persona_giuridica">{{ $root.translate('dizionario.progetti.AZIENDA') }}</option>
							<option value="persona_fisica">{{ $root.translate('dizionario.progetti.PERSONA_FISICA') }}</option>
						</select>
					</div>
					<div class="mb-2" v-show="duplicaProgettoDati.tipoCliente == 'persona_giuridica'">
						<label class="form-label fw-semibold">
							<Translate :path="'dizionario.progetti.AZIENDA'"></Translate> <span class="text-danger">*</span>
							<span class="badge bg-success ms-1" style="cursor:pointer"
								@click="apriNuovaAziendaDuplica()">{{ $root.translate('dizionario.base.BTN_NUOVA') }}</span>
						</label>
						<Select2
							v-model="duplicaProgettoDati.INTESTATARIO_FK_ID_PERSONA_GIURIDICA"
							:api="'theb-s2/clienti'"
							:apiselected="'theb-s2/clienti/selected?a=1'"
							msg-inattivo="Azienda non attiva, attivala prima di procedere"
							style="width:100%">
						</Select2>
					</div>
					<div class="mb-2" v-show="duplicaProgettoDati.tipoCliente == 'persona_fisica'">
						<label class="form-label fw-semibold">
							<Translate :path="'dizionario.progetti.PERSONA_FISICA'"></Translate> <span class="text-danger">*</span>
							<span class="badge bg-success ms-1" style="cursor:pointer"
								@click="apriNuovaPersonaFisicaDuplica()">{{ $root.translate('dizionario.base.BTN_NUOVA') }}</span>
						</label>
						<Select2
							v-model="duplicaProgettoDati.INTESTATARIO_FK_ID_PERSONA_FISICA"
							:api="'theb-s2/persone-fisiche'"
							:apiselected="'theb-s2/persone-fisiche/selected?a=1'"
							msg-inattivo="Persona fisica non attiva, attivala prima di procedere"
							style="width:100%">
						</Select2>
					</div>
					<div class="mb-3" v-show="duplicaProgettoDati.includi_attivita">
						<label class="form-label fw-semibold"><Translate :path="'dizionario.progetti.REVISIONE_COPIARE'"></Translate> <span
								class="text-danger">*</span></label>
						<select class="form-select" v-model="duplicaProgettoDati.ID_REVISIONE">
							<option value="">-- Seleziona revisione --</option>
							<option v-for="rev in duplicaProgettoDati.arrayRevisioni" :key="rev.ID_REVISIONE"
								:value="rev.ID_REVISIONE">
								Rev. {{ rev.PROGRESSIVO }} - {{ rev.DATA_CREAZIONE?.substring(0, 10) }}<span
									v-if="rev.NOTE"> - {{ rev.NOTE }}</span>
							</option>
						</select>
					</div>

					<div class="mb-2 mt-3">
						<label class="form-label fw-semibold"><Translate :path="'dizionario.progetti.COSA_DUPLICARE'"></Translate></label>
						<div class="d-flex flex-column gap-1">
							<div class="form-check">
								<input class="form-check-input" type="checkbox" id="dupAttivita"
									v-model="duplicaProgettoDati.includi_attivita">
								<label class="form-check-label" for="dupAttivita">
									<i class="fad fa-tasks me-1 text-primary"></i> <Translate :path="'dizionario.progetti.ATTIVITA_BUDGET'"></Translate>
								</label>
							</div>
							<div class="form-check">
								<input class="form-check-input" type="checkbox" id="dupListe"
									v-model="duplicaProgettoDati.includi_liste">
								<label class="form-check-label" for="dupListe">
									<i class="fal fa-tag fa-fw me-1 text-success"></i> <Translate :path="'dizionario.progetti.LISTE'"></Translate>
								</label>
							</div>
							<div class="form-check">
								<input class="form-check-input" type="checkbox" id="dupModalita"
									v-model="duplicaProgettoDati.includi_modalita_pagamento">
								<label class="form-check-label" for="dupModalita">
									<i class="fad fa-credit-card me-1 text-warning"></i> <Translate :path="'dizionario.progetti.MODALITA_PAGAMENTO'"></Translate>
								</label>
							</div>
							<div class="form-check">
								<input class="form-check-input" type="checkbox" id="dupUtenti"
									v-model="duplicaProgettoDati.includi_utenti_condivisi">
								<label class="form-check-label" for="dupUtenti">
									<i class="fad fa-users me-1 text-info"></i> <Translate :path="'dizionario.progetti.UTENTI_CONDIVISI'"></Translate>
								</label>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer bg-light p-2">
					<button type="button" class="btn btn-link" data-bs-dismiss="modal"><Translate :path="'dizionario.base.BTN_ANNULLA'"></Translate></button>
					<button type="button" class="btn btn-info text-white" @click="eseguiDuplicaProgetto()"
						:disabled="duplicaBloccata || (!duplicaProgettoDati.INTESTATARIO_FK_ID_PERSONA_GIURIDICA && !duplicaProgettoDati.INTESTATARIO_FK_ID_PERSONA_FISICA) || (duplicaProgettoDati.includi_attivita && !duplicaProgettoDati.ID_REVISIONE)">
						<i class="fad fa-copy me-1"></i> <Translate :path="'dizionario.progetti.DUPLICA'"></Translate>
					</button>
				</div>
			</div>
		</div>
	</div>

	<!-- Modale Modalità Esportazione Excel -->
	<div class="modal fade" id="popUpModalitaEsportazione" role="dialog" tabindex="-1" data-bs-backdrop="static">
		<div class="modal-dialog modal-md" role="document">
			<div class="modal-content">
				<div class="modal-header modal-header-2 bg-success text-white">
					<h6 class="modal-title">
						<i class="far fa-file-excel me-2"></i>Seleziona Modalità Esportazione
					</h6>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
				</div>

				<div class="modal-body">
					<div class="mb-3">
						<label class="form-label fw-semibold">In che modalità vuoi esportarla?</label>
						<select class="form-select" v-model="modalitaEsportazioneSelezionata">
							<option value="">Seleziona una modalità...</option>
							<option v-for="opzione in arrayModalitaEsportazione" :key="opzione.ID_OPZIONE_TIPOLOGICA"
								:value="opzione.ICONA">
								{{ opzione.DESCRIZIONE }}
							</option>
						</select>
					</div>

					<!-- Spiegazioni modalità -->
					<div v-if="modalitaEsportazioneSelezionata == 1005" class="alert alert-info mb-0 mx-3">
						<div class="fw-semibold mb-1">
							<i class="far fa-info-circle me-1"></i>Modalità MISTA
						</div>
						<div class="small">
							Le <strong>attività principali</strong> (stesso livello) verranno esportate su <strong>fogli separati</strong>.
							Assicurati che le attività principali siano tutte allo stesso livello gerarchico.
						</div>
					</div>

					<div v-if="modalitaEsportazioneSelezionata == 1007" class="alert alert-info mb-0 mx-3">
						<div class="fw-semibold mb-1">
							<i class="far fa-info-circle me-1"></i>Modalità UNICA
						</div>
						<div class="small">
							Tutte le attività verranno esportate in un <strong>unico foglio</strong>.
							<br>Se vuoi che il foglio porti il nome del progetto, crea un'attività principale che racchiuda tutte le altre.
						</div>
					</div>
				</div>

				<div class="modal-footer bg-light p-2">
					<button type="button" class="btn btn-link" data-bs-dismiss="modal">
						<i class="fal fa-times me-1"></i> Annulla
					</button>
					<button type="button" class="btn btn-success" @click="confermaEsportazioneExcel()">
						<i class="far fa-file-excel me-1"></i> Esporta
					</button>
				</div>
			</div>
		</div>
	</div>

	<ModalAllTask ref="modalAllTask" :modulo="parseInt((filters.getModuloCorrente($root.$route.path)).ICONA)" @taskMultiplaCreata="arraySelezionati = []" />

	<ModalNuovaRevisione
		v-if="progettoSelezionatoPerRevisione"
		ref="modalNuovaRevisione"
		:fk-id-progetto="progettoSelezionatoPerRevisione.ID_PROGETTO"
		:progressivo-corrente="progettoSelezionatoPerRevisione.PROGRESSIVO_REVISIONE_CORRENTE || 0"
		@revisione-creata="onRevisioneCreataProgetti()"
	/>

	<SchedaAzienda ref="schedaAziendaDuplica" :tipo="1" @aziendaSalvata="onAziendaSalvataDuplica"></SchedaAzienda>
	<SchedaUtente ref="schedaUtenteDuplica" @updateGriglia="onPersonaFisicaSalvataDuplica"></SchedaUtente>

	<PopUpEsportazione id="popUpEsportazioneProgetti" @esporta="esportaDatiTabella" />

	<!-- Modale Template di stampa Budget PDF -->
	<ReportTemplateModal id="popUpStampaBudget" :idReport="1006" :urlStampa="urlStampaBudget"></ReportTemplateModal>

	<ModalAllegati v-if="progettoAllegati" tipo="progetto" :id="progettoAllegati.ID_PROGETTO" :titolo="progettoAllegati.TITOLO" @close="progettoAllegati = null" />

	<!-- Modal utenti condivisi -->
	<div class="modal fade" id="modalUtentiCondivisi" tabindex="-1">
		<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h5 class="modal-title">
						<i class="fa fa-users me-2"></i>Team
					</h5>
					<button type="button" class="btn-close btn-close-white"
						@click="filters.closePopUp('modalUtentiCondivisi')"></button>
				</div>
				<div class="modal-body">
					<p class="text-muted small mb-3">{{ popupUtentiCondivisi.nomeProgetto }}</p>
					<div v-if="popupUtentiCondivisi.accountUsername" class="d-flex align-items-center pb-2 mb-2 border-bottom">
						<img v-if="popupUtentiCondivisi.accountAvatar && popupUtentiCondivisi.accountAvatar != 'placeholder.jpg'"
							:src="filters.getImgPath('USERS', popupUtentiCondivisi.accountAvatar)" alt="avatar" class="rounded-circle avatar-xxs me-2">
						<div v-else class="avatar-xxs rounded-circle bg-light d-flex align-items-center justify-content-center me-2">
							<i class="fa fa-user-crown text-secondary" style="font-size:0.8rem"></i>
						</div>
						<span class="small fw-semibold">{{ popupUtentiCondivisi.accountUsername }}</span>
						<span class="badge bg-primary ms-auto">Account Manager</span>
					</div>
					<div class="d-flex align-items-center mb-2"
						v-for="u in popupUtentiCondivisi.utenti" :key="u.ID_UTENTE">
						<img v-if="u.ID_UTENTE > 0 && u.URL_AVATAR != 'placeholder.jpg'"
							:src="filters.getImgPath('USERS',u.URL_AVATAR)" alt="avatar" class="rounded-circle avatar-xxs me-2">
						<div v-else
							class="avatar-xxs rounded-circle bg-light d-flex align-items-center justify-content-center me-2">
							<i class="fa fa-user text-secondary" style="font-size:0.65rem"></i>
						</div>
						<span class="small">{{ u.USERNAME }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Modal utenti condivisi -->
	<div class="modal fade" id="modalNote" tabindex="-1">
		<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h5 class="modal-title">
						NOTE
					</h5>
					<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" @click="filters.closePopUp('modalNote')">
						<i class="ph-x icon-x-size"></i>
					</button>
				</div>
				<div class="modal-body">

					{{ progettoSelezionato.NOTE }}

				</div>
			</div>
		</div>
	</div>

</template>



<script>

import Pagine from '@/components/utils/Pagine.vue'
import ISwitch from '@/components/utils/ISwitch.vue'
import Select2 from '@/components/utils/Select2.vue'
import Select2Locale from '@/components/utils/Select2Locale.vue'
import ISort from '@/components/utils/ISort.vue'
import { VueDraggableNext } from 'vue-draggable-next'
import Upload from '@/components/utils/Upload.vue'
import SchedaProgetto from '@/components/SchedaProgetto.vue'
import SchedaVisualizzazioneProgetto from '@/components/SchedaVisualizzazioneProgetto.vue'
import SchedaAttivita from '@/components/SchedaAttivita.vue'
import ModalAllTask from '@/components/ModalAllTask.vue'
import ModalNuovaRevisione from '@/components/ModalNuovaRevisione.vue'
import SchedaAzienda from '@/components/SchedaAzienda.vue'
import SchedaUtente from '@/components/SchedaUtente.vue'
import PopUpEsportazione from '@/components/common/PopUpEsportazione.vue'
import ReportTemplateModal from '@/components/common/ReportTemplateModal.vue'
import ModalAllegati from '@/components/ModalAllegati.vue'

const TIPOLOGICA_POSIZIONI = 57;

export default {
	name: "Progetti",

	components: {
		Pagine,
		ISwitch,
		Select2,
		Select2Locale,
		ISort,
		draggable: VueDraggableNext,
		Upload,
		SchedaProgetto,
		SchedaVisualizzazioneProgetto,
		SchedaAttivita,
		ModalAllTask,
		ModalNuovaRevisione,
		SchedaAzienda,
		SchedaUtente,
		PopUpEsportazione,
		ReportTemplateModal,
		ModalAllegati,
	},

	data: function () {
		return {
			apiStartup: 'theb/progetto/lista',
			filters: global.filters,
			progettoAllegati: null,
			windowWidth: window.innerWidth,
			GLOBAL_IMAGES_PATH: '',
			TIPOLOGICA_POSIZIONI: TIPOLOGICA_POSIZIONI,
			anno: new Date().getFullYear(),
			//arrayStatiProgetto: new Array(),
			arrayStatiProgetto: filters.getOpzioniTipologiche(58,1),
			arrayVociPreferite: new Array(),
			optionsAmministratoriFiltro: new Array(),
			optionsListeFiltroRaw: new Array(),
			arrayProgetti: new Array(),
			progettoSelezionato: { enti: new Array(), storico: new Array() },
			progettoCorrente: {},
			viewMode: 'table',
			search: {
				PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 25 },
				ID_PROGETTO: { TYPE: 'TEXT', VALUE: '' },
				TITOLO: { TYPE: 'TEXT', VALUE: '' },
				CODICE_PROGETTO: { TYPE: 'TEXT', VALUE: '' },
				CLIENTE: { TYPE: 'TEXT', VALUE: '' },
				ACCOUNT: { TYPE: 'COMBO', VALUE: '' },
				LISTE: { TYPE: 'COMBO', VALUE: '' },
				FORNITORE: { TYPE: 'COMBO', VALUE: 0 },
				FK_ID_STATO: { TYPE: 'COMBO', VALUE: '' },
				ANNO: { TYPE: 'COMBO', VALUE: new Date().getFullYear() },
				FLG_ATTIVO: { TYPE: 'COMBO', VALUE: '1' },
				FLG_ELIMINATO: { TYPE: 'COMBO', VALUE: '0' }
			},
			rs: utils.generateRandomString(30),
			argsProgetto: {
				modalita: 'THEB_uploadImgProgetto'
			},
			ordinamento: '',
			searchStorico: { PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 15 } },
			dettagliStorico: {},
			idLogAperto: 0,

			lockDuplica: null,
			lockOrdine: null,
			lockOrdineHandle: null,
			lockDuplicaHandle: null,
			duplicaProgettoDati: {
				progettoOrigine: null,
				tipoCliente: '',
				INTESTATARIO_FK_ID_PERSONA_GIURIDICA: null,
				INTESTATARIO_FK_ID_PERSONA_FISICA: null,
				ID_REVISIONE: '',
				arrayRevisioni: [],
				includi_attivita: true,
				includi_liste: true,
				includi_modalita_pagamento: true,
				includi_utenti_condivisi: true
			},

			draggedProgettoId: null,

			progettoSelezionatoPerRevisione: null,

			// Modalità esportazione Excel
			arrayModalitaEsportazione: filters.getOpzioniTipologiche(59),
			modalitaEsportazioneSelezionata: null,
			progettoDaEsportare: null,

			// Toggle per visualizzare percentuale del margine
			showMarginePercentage: false,

			// Export tabella
			esportazioneTipo: '',

			// Popup utenti condivisi
			popupUtentiCondivisi: {
				nomeProgetto: '',
				utenti: [],
			},

		}

	},

	methods: {

		apriPopupUtenti(progetto) {
			this.popupUtentiCondivisi.nomeProgetto = progetto.NOME;
			this.popupUtentiCondivisi.utenti = this.utentiCondivisi(progetto);
			this.popupUtentiCondivisi.accountUsername = progetto.ACCOUNT_USERNAME;
			this.popupUtentiCondivisi.accountAvatar = progetto.ACCOUNT_AVATAR;
			this.filters.openPopUp('modalUtentiCondivisi');
		},
		apriPopUpNote(progetto) {
			this.progettoSelezionato.NOTE = progetto.NOTE;
			this.filters.openPopUp('modalNote');
		},

		utentiCondivisi(progetto) {
			return (progetto.UTENTI_CONDIVISI || []).filter(u => u.ID_UTENTE != progetto.FK_ID_UTENTE);
		},

		/**
		 * Calcola la percentuale del margine rispetto al budget
		 */
		getMarginePercentage: function () {
			const budget = parseFloat(this.getTotali.GRAND_TOTAL) || 0;
			const margine = parseFloat(this.getTotali.MARGINE) || 0;
			if (budget == 0) return 0;
			return ((margine / budget) * 100).toFixed(2);
		},

		/**
		 * Toggle visualizzazione percentuale margine
		 */
		toggleMarginePercentage: function () {
			this.showMarginePercentage = !this.showMarginePercentage;
		},

		storicoProgetto: function (progetto) {
			utils.get("theb/progetto/storico", { ID_PROGETTO: progetto.ID_PROGETTO, FLG_STORICO: 1 }, (response) => {
				this.searchStorico.PAGINATION.PAGE_NUMBER = 1;
				this.dettagliStorico = {};
				this.idLogAperto = 0;
				this.progettoSelezionato = response.data;
				this.filters.openPopUp("popUpStoricoProgetto");
			});
		},

		onKanbanDragStart: function (evt) {
			this.draggedProgettoId = parseInt(evt.item.dataset.id);
			var container = this.$refs.kanbanContainer;
			if (container) {
				this._kanbanScrollTimer = null;
				this._kanbanTouchScrollHandler = function (e) {
					var touch = e.touches[0];
					if (!touch) return;
					var rect = container.getBoundingClientRect();
					var x = touch.clientX;
					var threshold = 80;
					var speed = 10;
					clearInterval(this._kanbanScrollTimer);
					if (x < rect.left + threshold) {
						this._kanbanScrollTimer = setInterval(function () { container.scrollLeft -= speed; }, 20);
					} else if (x > rect.right - threshold) {
						this._kanbanScrollTimer = setInterval(function () { container.scrollLeft += speed; }, 20);
					}
				}.bind(this);
				document.addEventListener('touchmove', this._kanbanTouchScrollHandler, { passive: true });
			}
		},

		onKanbanDrop: function (evt) {
			document.removeEventListener('touchmove', this._kanbanTouchScrollHandler);
			clearInterval(this._kanbanScrollTimer);
			if (!this.draggedProgettoId) return;

			var nuovoStatoId = parseInt(evt.to.dataset.statoId);
			var progetto = this.arrayProgetti.find(p => p.ID_PROGETTO == this.draggedProgettoId);

			if (!progetto || progetto.FK_ID_STATO == nuovoStatoId) {
				this.draggedProgettoId = null;
				return;
			}

			var vecchioStato = progetto.FK_ID_STATO;
			progetto.FK_ID_STATO = nuovoStatoId;

			utils.put('theb/progetto/cambiastato', {
				ID_PROGETTO: this.draggedProgettoId,
				ID_STATO_PROGETTI: this.idModulo(),
				FK_ID_STATO: nuovoStatoId
			}, (response) => {
				if (response.esito == 0) {
					utils.alert.success('Stato progetto aggiornato');
					this.getProgetti();
				} else {
					progetto.FK_ID_STATO = vecchioStato;
					utils.alert.warning(response.messaggio);
					this.getProgetti();
				}
				this.draggedProgettoId = null;
			}, true, 1);
		},

		toggleDettaglioStorico: function (operazione) {
			if (this.idLogAperto == operazione.ID_LOG) {
				this.idLogAperto = 0;
				return;
			}
			this.idLogAperto = operazione.ID_LOG;
			if (this.dettagliStorico[operazione.ID_LOG]) return;
			utils.get("theb/progetto/log/dettaglio", {
				ID_PROGETTO: operazione.FK_ID_PROGETTO,
				NOME_FILE: operazione.NOME_FILE
			}, (response) => {
				this.dettagliStorico[operazione.ID_LOG] = {
					righe: response.esito == 0 ? this.righeDettaglioStorico(response.data.dettaglioModifiche) : null
				};
			}, true, 1);
		},

		righeDettaglioStorico: function (modifiche) {
			if (Array.isArray(modifiche)) return modifiche;
			if (typeof modifiche != 'string') return [];
			return modifiche.split('\n').filter(riga => riga.trim() != '').map(riga => this.parseModifiche(riga)[0] || { testo: riga })
				.filter(m => m.testo || m.vecchio.trim() != m.nuovo.trim());
		},

		giornoStorico: function (operazione) {
			return String(operazione.DATA_AZIONE).substring(0, 10);
		},

		tipoOperazione: function (descrizione) {
			var d = String(descrizione);
			if (d.indexOf('DELETE') > -1) return { colore: 'danger', icona: 'fa-trash' };
			if (d.indexOf('INSERT') == 0) return { colore: 'success', icona: 'fa-plus' };
			if (d.indexOf('UPDATE') == 0) return { colore: 'primary', icona: 'fa-pencil' };
			return { colore: 'secondary', icona: 'fa-history' };
		},

		parseModifiche: function (dettaglioModifiche) {
			if (!dettaglioModifiche || dettaglioModifiche.trim() == '') {
				return [];
			}
			const righe = dettaglioModifiche.split('\n');
			const modifiche = [];

			righe.forEach(riga => {
				const match = riga.match(/^(.+?):\s*'(.*)'\s*→\s*'(.*)'$/);
				if (match) {
					modifiche.push({
						campo: match[1].trim(),
						vecchio: match[2],
						nuovo: match[3]
					});
				}
			});

			return modifiche;
		},

		titoloModalitaPagamento: function (progetto){
			const attive = parseInt(progetto.NUM_MODALITA_PAGAMENTO_ATTIVE) || 0;
			const disattive = parseInt(progetto.NUM_MODALITA_PAGAMENTO_DISATTIVE) || 0;
			const parti = [];
			if(attive > 0){
				parti.push(attive + ( attive == 1 ? ' attiva' : ' attive'));
			}
			if(disattive > 0){
				parti.push(disattive + ( disattive == 1 ? ' disattiva' : ' disattive'));
			}
			return 'Modalità pagamento: ' + parti.join(', ')
		},

		idModulo: function () {
			return parseInt((this.filters.getModuloCorrente(this.$root.$route.path)).ICONA);
		},

		getProgetti: function () {
			const anno = this.search.ANNO.VALUE || null;
			utils.get(this.apiStartup, { ANNO: anno, FK_ID_MODULO: this.idModulo() }, (response) => {
				this.arrayProgetti = response.data;
				// Ordina i progetti per ORDINE
				this.arrayProgetti.sort((a, b) => (a.ORDINE || a.ID_PROGETTO) - (b.ORDINE || b.ID_PROGETTO));
			});
		},

		getProgetto: function(idProgetto){
			this.progettoSelezionato.ID_PROGETTO = idProgetto;
		},

		startUp: function () {
			utils.get('theb/voci_preferite/lista', {}, response => {
				this.arrayVociPreferite = response.data || [];
				this.getProgetti();
			});
		},

		nuovoProgetto: function () {
			this.progettoSelezionato = { ID_PROGETTO: 0, FK_ID_ENTE: this.$root.idEnteCorrente };
			this.$refs.schedaProgetto.openSchedaProgetto(this.progettoSelezionato);
		},

		modificaProgetto: function (progetto) {
			var myOffcanvas = document.getElementById('panel_right');
			if (myOffcanvas) {
				var bsOffcanvas = bootstrap.Offcanvas.getInstance(myOffcanvas);
				if (bsOffcanvas) {
					bsOffcanvas.hide();
				}
			}
			this.progettoSelezionato = utils.clone(progetto);
			this.$refs.schedaProgetto.openSchedaProgetto(this.progettoSelezionato);

		},

		gestisciAttivita: function (progetto) {
			this.$root.progetto = progetto;
			global.router.push('Attivita');
		},
		openOffCanvas: function () {
			var myOffcanvas = document.getElementById('panel_right')
			var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas)
			bsOffcanvas.show();
		},
		
		openSchedaVisualizzazioneProgetto: function (progetto, tab = "", opzioni = null) {
			this.progettoSelezionato = utils.clone(progetto);
			this.$refs.schedaVisualizzazioneProgetto.openSchedaVisualizzazioneProgetto(progetto, tab, opzioni);
		},
		
		updateStatoProgetto: function (progetto) {
			setTimeout(() => {
				utils.ajax('theb/list/stato/update', progetto, (response) => {
					if (response.esito == 0) {
						utils.alert.success(response.messaggio);
						this.filters.closePopUp("popUpProgetto");
					}
				});
			}, 250);
		},

		updateStato: function (progetto) {
			// Aggiorna solo il campo STATO del progetto
			utils.put('theb/progetto/update', progetto, (response) => {
				if (response.esito == 0) {
					utils.alert.success('Stato progetto aggiornato con successo');
					this.getProgetti();
				} else {
					utils.alert.danger('Errore nell\'aggiornamento dello stato: ' + response.messaggio);
				}
			});
		},

		deleteCategoria: function (t) {
			utils.alert.confirm("Sicuro di voler eliminare questo Progetto " + t.NOME + "?", () => {
				utils.ajax('theb/list/delete', { className: 'Progetto', id: t.ID_PROGETTO }, (response) => {
					if (response.esito == 0) {
						utils.alert.success(response.messaggio);
						this.getProgetti();
					}
				});
			});
		},

		apriEsportazione: function(tipo) {
			this.esportazioneTipo = tipo;
			this.filters.openPopUp('popUpEsportazioneProgetti');
		},

		esportaDatiTabella: function(formato) {
			utils.esportaTabella({
				tipo:          this.esportazioneTipo,
				formato:       formato,
				arrayCompleto: this.arrayProgetti,
				arrayPagina:   this.paginatedList.arr,
				idField:       'ID_PROGETTO',
				modulo:        'progetti',
				nomeFile:      'progetti'
			});
		},

		esportazione: function (formato) {
			utils.report.token({ modalita: 'esportaProgetti', formato: formato });
		},

		esportaProgettiExcel: function () {
			var url = utils.BASE_API + "chad_2/report?ID_REPORT=4&FORMATO=2" + utils.getSessionToken();
			window.open(url);
		},

		apriModalitaEsportazione: function (progetto) {
			this.progettoDaEsportare = progetto;
			this.modalitaEsportazioneSelezionata = '1007';
			this.filters.openPopUp('popUpModalitaEsportazione');
		},

		confermaEsportazioneExcel: function () {
			if (!this.modalitaEsportazioneSelezionata) {
				utils.alert.warning('Seleziona una modalità di esportazione');
				return;
			}
			const idReport = this.modalitaEsportazioneSelezionata;
			this.filters.closePopUp('popUpModalitaEsportazione');
			window.open(utils.BASE_API + "theb/report?ID_REPORT=" + idReport + "&FK_ID_PROGETTO=" + this.progettoDaEsportare.ID_PROGETTO + "&LANG=" + this.$root.currentLang + utils.getSessionToken());
		},
		esportaBudgetPdf(progetto) {
			this.progettoDaEsportare = progetto;
			this.filters.openPopUp('popUpStampaBudget');
		},

		uploadImmagineProgetto: function (progetto) {
			this.progettoSelezionato = utils.clone(progetto);
			this.argsProgetto.ID_PROGETTO = progetto.ID_PROGETTO;
			this.filters.openPopUp("popUpUploadImgProgetto" + this.rs);
		},

		successCaricamento: function () {
			this.filters.closePopUp("popUpUploadImgProgetto" + this.rs);
			utils.get("theb/progetto/dettaglio", { ID_PROGETTO: this.progettoSelezionato.ID_PROGETTO }, (response) => {
				if (response.esito == 0 && response.data && response.data.length > 0) {
					this.progettoSelezionato = utils.clone(response.data[0]);
				}
				this.getProgetti();
			});
		},

		errorCaricamento: function () {
			this.filters.closePopUp("popUpUploadImgProgetto" + this.rs);
		},

		// lock per modulo: chi ordina un modulo non blocca gli altri; nel kanban il drag cambia lo stato
		attivaOrdine: function () {
			this.ordinamento = '';
			this.lockOrdineHandle = utils.lock.acquire(this.viewMode == 'kanban' ? 'STATO_PROGETTI' : 'ORDINE_PROGETTI',this.idModulo(), (stato) => this.lockOrdine = stato, this.getProgetti);
		},

		disattivaOrdine: function () {
			utils.lock.release(this.lockOrdineHandle);
			this.lockOrdineHandle = null;
			this.lockOrdine = null;
		},

		// le righe a video sono filtrate/paginate: sposto il progetto in arrayProgetti accanto al suo nuovo vicino
		ordineChangeHandler: function (evt) {
			var vista = this.paginatedList.arr;
			var spostato = vista[evt.newIndex];
			var dopo = vista[evt.newIndex + 1];
			var vicino = dopo || vista[evt.newIndex - 1];
			if (evt.oldIndex == evt.newIndex || !spostato || !vicino) return;
			this.arrayProgetti.splice(this.arrayProgetti.indexOf(spostato), 1);
			this.arrayProgetti.splice(this.arrayProgetti.indexOf(vicino) + (dopo ? 0 : 1), 0, spostato);
			for (var i = 0; i < this.arrayProgetti.length; i++) {
				this.arrayProgetti[i]['ORDINE'] = (i + 1);
			}

			utils.put('theb/progetto/ordine', {
				ID_ORDINE_PROGETTI: this.idModulo(),
				progetti: this.arrayProgetti.map((progetto) => ({
					ID_PROGETTO: progetto.ID_PROGETTO,
					ORDINE: progetto.ORDINE
				}))
			}, (response) => {
				if (response.esito == 0) utils.alert.success('Ordinamento salvato con successo');
				else utils.alert.warning('Errore: ' + (response.messaggio || "Errore durante il salvataggio dell'ordinamento"));
				this.getProgetti();
			}, true, 0, "POST");
		},

		statisticheStartup: function () {
			this.$refs.statistiche.statisticheStartup();
		},

		calcolaTotalePrezzo: function () {
			const quantity = parseFloat(this.costoFissoSelezionato.QUANTITY) || 0;
			const days = parseFloat(this.costoFissoSelezionato.DAYS) || 0;
			const unitPrice = parseFloat(this.costoFissoSelezionato.UNIT_PRICE) || 0;
			this.costoFissoSelezionato.TOTAL_PRICE = (unitPrice * quantity * days).toFixed(2);
		},

		calcolaTotaleCosto: function () {
			const quantity = parseFloat(this.costoFissoSelezionato.QUANTITY) || 0;
			const days = parseFloat(this.costoFissoSelezionato.DAYS) || 0;
			const unitCost = parseFloat(this.costoFissoSelezionato.UNIT_COST) || 0;
			this.costoFissoSelezionato.TOTAL_COST = (unitCost * quantity * days).toFixed(2);
		},

		apriDuplicaProgetto: function (progetto) {
			this.duplicaProgettoDati.progettoOrigine = progetto;
			this.duplicaProgettoDati.tipoCliente = '';
			this.duplicaProgettoDati.INTESTATARIO_FK_ID_PERSONA_GIURIDICA = null;
			this.duplicaProgettoDati.INTESTATARIO_FK_ID_PERSONA_FISICA = null;
			this.duplicaProgettoDati.ID_REVISIONE = '';
			this.duplicaProgettoDati.arrayRevisioni = [];
			this.duplicaProgettoDati.includi_attivita = true;
			this.duplicaProgettoDati.includi_liste = true;
			this.duplicaProgettoDati.includi_modalita_pagamento = true;
			this.duplicaProgettoDati.includi_utenti_condivisi = true;
			utils.get('theb/revisione/progetto', { ID_PROGETTO: progetto.ID_PROGETTO }, (response) => {
				if (response.esito == 0) {
					this.duplicaProgettoDati.arrayRevisioni = response.data || [];
				}
			});
			this.rilasciaLockDuplica();
			this.lockDuplicaHandle = utils.lock.acquire('PROGETTO_DUPLICA', progetto.ID_PROGETTO, (stato) => this.lockDuplica = stato);
			this.filters.openPopUp('popUpDuplicaProgetto' + this.rs);
		},

		rilasciaLockDuplica: function () {
			utils.lock.release(this.lockDuplicaHandle);
			this.lockDuplicaHandle = null;
			this.lockDuplica = null;
		},

		eseguiDuplicaProgetto: function () {
			const hasCliente = this.duplicaProgettoDati.INTESTATARIO_FK_ID_PERSONA_GIURIDICA ||
							   this.duplicaProgettoDati.INTESTATARIO_FK_ID_PERSONA_FISICA;
			if (!hasCliente) {
				utils.alert.warning('Seleziona intestatario');
				return;
			}
			if (this.duplicaProgettoDati.includi_attivita && !this.duplicaProgettoDati.ID_REVISIONE) {
				utils.alert.warning('Seleziona una revisione da copiare');
				return;
			}
			const payload = {
				ID_PROGETTO_DUPLICA: this.duplicaProgettoDati.progettoOrigine.ID_PROGETTO,
				INTESTATARIO_FK_ID_PERSONA_GIURIDICA: this.duplicaProgettoDati.INTESTATARIO_FK_ID_PERSONA_GIURIDICA || 0,
				INTESTATARIO_FK_ID_PERSONA_FISICA: this.duplicaProgettoDati.INTESTATARIO_FK_ID_PERSONA_FISICA || 0,
				FK_ID_STATO: this.duplicaProgettoDati.progettoOrigine.FK_ID_STATO || 0,
				ID_REVISIONE: this.duplicaProgettoDati.ID_REVISIONE || 0,
				NOTE: `Duplica del progetto ${this.duplicaProgettoDati.progettoOrigine.TITOLO} (ID: ${this.duplicaProgettoDati.progettoOrigine.ID_PROGETTO})`,
				INCLUDI_ATTIVITA: this.duplicaProgettoDati.includi_attivita ? 1 : 0,
				INCLUDI_LISTE: this.duplicaProgettoDati.includi_liste ? 1 : 0,
				INCLUDI_MODALITA_PAGAMENTO: this.duplicaProgettoDati.includi_modalita_pagamento ? 1 : 0,
				INCLUDI_UTENTI_CONDIVISI: this.duplicaProgettoDati.includi_utenti_condivisi ? 1 : 0
			};
			utils.post('theb/progetto/duplica', payload, (response) => {
				if (response.esito == 0) {
					this.filters.closePopUp('popUpDuplicaProgetto' + this.rs);
					this.startUp();
					utils.alert.success('Progetto duplicato con successo!');
					utils.notifiche.invia(this, 'PROGETTO_CREA', 'ha duplicato il progetto "' + this.duplicaProgettoDati.progettoOrigine.TITOLO + '"');
				} else {
					utils.alert.warning('Errore: ' + response.messaggio);
				}
			});
		},

		apriNuovaAziendaDuplica() {
			const aziendaNuova = {
				ID_AZIENDA: 0,
				FK_ID_TIPO: 1,
				personaGiuridica: {
					ALIAS: '',
					RAGIONE_SOCIALE: '',
					COGNOME: '',
					NOME: ''
				}
			};
			this.$nextTick(() => {
				this.$refs.schedaAziendaDuplica.openSchedaAzienda(aziendaNuova);
			});
		},

		onAziendaSalvataDuplica(azienda) {
			this.duplicaProgettoDati.tipoCliente = 'persona_giuridica';
			this.duplicaProgettoDati.INTESTATARIO_FK_ID_PERSONA_GIURIDICA = azienda.FK_ID_PERSONA_GIURIDICA;
			this.duplicaProgettoDati.INTESTATARIO_FK_ID_PERSONA_FISICA = null;
			this.$refs.schedaAziendaDuplica.chiudi();
		},

		apriNuovaPersonaFisicaDuplica() {
			this.$refs.schedaUtenteDuplica.openSchedaUtente({ ID_UTENTE: 0, persona: {}, FK_ID_LIVELLO: 5 });
		},

		onPersonaFisicaSalvataDuplica() {
			var newId = this.$refs.schedaUtenteDuplica.utente.ID_UTENTE;
			this.$refs.schedaUtenteDuplica.chiudi();
			utils.get("core/utente",{ID_UTENTE:newId}, (response) => {
			this.duplicaProgettoDati.tipoCliente = 'persona_fisica';
				this.duplicaProgettoDati.INTESTATARIO_FK_ID_PERSONA_FISICA = response.data.UTENTE.FK_ID_PERSONA_FISICA;
			this.duplicaProgettoDati.INTESTATARIO_FK_ID_PERSONA_GIURIDICA = null;
			});
		},

		getStatoColore: function (idStato) {
			var stato = this.arrayStatiProgetto.find(s => s.CUSTOM_1 == idStato);
			return stato ? (stato.ICONA || '#6c757d') : '#6c757d';
		},

		getStatoDescrizione: function (idStato) {
			var stato = this.arrayStatiProgetto.find(s => s.CUSTOM_1 == idStato);
			return stato ? stato.DESCRIZIONE : 'N/D';
		},

		toggleFlgAttivoProgetto: function (progetto, newValue) {
			utils.put('theb/progetto/flg', {ID_PROGETTO: progetto.ID_PROGETTO, FLG_ATTIVO: newValue}, (response) => {
				if (response.esito == 0) {
					this.getProgetti();
				}
			});
		},

		attivaSelezionati() {
			var sel = utils.array.select(this.arrayProgetti, 'SELEZIONATO', 1);
			if (sel.length == 0) { utils.alert.warning('Nessun progetto selezionato.'); return; }
			utils.alert.confirm('Attivare ' + sel.length + ' progetti?', () => {
				utils.put('theb/progetto/attiva-bulk', { IDS: sel.map(p => p.ID_PROGETTO) }, (r) => {
					if (r.esito == 0) { this.getProgetti(); utils.alert.success('Progetti attivati con successo.'); }
				});
			}, this.$root);
		},
		disattivaSelezionati() {
			var sel = utils.array.select(this.arrayProgetti, 'SELEZIONATO', 1);
			if (sel.length == 0) { utils.alert.warning('Nessun progetto selezionato.'); return; }
			utils.alert.confirm('Disattivare ' + sel.length + ' progetti?', () => {
				utils.put('theb/progetto/disattiva-bulk', { IDS: sel.map(p => p.ID_PROGETTO) }, (r) => {
					if (r.esito == 0) { this.getProgetti(); utils.alert.success('Progetti disattivati con successo.'); utils.notifiche.invia(this, 'PROGETTO_ELIMINA', 'ha disattivato ' + sel.length + ' progetti'); }
				});
			}, this.$root);
		},

		eliminaProgetto: function (progetto) {
			utils.alert.confirm(`Sicuro di voler eliminare il progetto "${progetto.TITOLO}"?`, () => {
				utils.delete('theb/progetto/delete', { ID_PROGETTO: progetto.ID_PROGETTO }, (response) => {
					if (response.esito == 0) {
						utils.alert.success('Progetto eliminato con successo.');
						this.getProgetti();
						utils.notifiche.invia(this, 'PROGETTO_ELIMINA', 'ha eliminato il progetto "' + progetto.TITOLO + '"');
					}
				});
			}, this.$root);
		},

		eliminaDefinitivamenteProgetto: function (progetto) {
			utils.alert.confirm(`Eliminare DEFINITIVAMENTE il progetto "${progetto.TITOLO}"? Azione irreversibile.`, () => {
				utils.delete('theb/progetto/harddelete', { ID_PROGETTO: progetto.ID_PROGETTO }, (response) => {
					if (response.esito == 0) {
						utils.alert.success('Progetto eliminato definitivamente.');
						this.getProgetti();
					}
				});
			}, this.$root);
		},


		ripristinaProgetto: function (progetto) {
			utils.alert.confirm(`Ripristinare il progetto "${progetto.TITOLO}"?`, () => {
				utils.put('theb/progetto/ripristina', { ID_PROGETTO: progetto.ID_PROGETTO }, (response) => {
					if (response.esito == 0) {
						utils.alert.success('Progetto ripristinato con successo.');
						this.getProgetti();
						utils.notifiche.invia(this, 'PROGETTO_MODIFICA', 'ha ripristinato il progetto "' + progetto.TITOLO + '"');
					}
				});
			},this.$root);
		},
		eliminaSelezionati() {
			var sel = this.arrayProgetti.filter(p => p.SELEZIONATO == 1 && p.FLG_ELIMINATO != 1);
			if (sel.length == 0) { utils.alert.warning('Nessun progetto selezionato.'); return; }
			utils.alert.confirm('Eliminare ' + sel.length + ' progetti?', () => {
				utils.delete('theb/progetto/delete-bulk', { IDS: sel.map(p => p.ID_PROGETTO) }, (r) => {
					if (r.esito == 0) { this.getProgetti(); utils.alert.success('Progetti eliminati con successo.'); utils.notifiche.invia(this, 'PROGETTO_ELIMINA', 'ha eliminato ' + sel.length + ' progetti'); }
				});
			}, this.$root);
		},
		ripristinaSelezionati() {
			var sel = this.arrayProgetti.filter(p => p.SELEZIONATO == 1 && p.FLG_ELIMINATO == 1);
			if (sel.length == 0) { utils.alert.warning('Nessun progetto eliminato selezionato.'); return; }
			utils.alert.confirm('Ripristinare ' + sel.length + ' progetti?', () => {
				utils.put('theb/progetto/ripristina-bulk', { IDS: sel.map(p => p.ID_PROGETTO) }, (r) => {
					if (r.esito == 0) { this.getProgetti(); utils.alert.success('Progetti ripristinati con successo.'); utils.notifiche.invia(this, 'PROGETTO_MODIFICA', 'ha ripristinato ' + sel.length + ' progetti'); }
				});
			}, this.$root);
		},

		apriToDo(item) {
			this.$refs.modalAllTask.apriModale(item.ID_PROGETTO);
		},

		addMoreTask() {
			const progettiSelezionati = this.arrayProgetti.filter(o => o.SELEZIONATO == 1);
			this.arraySelezionati = progettiSelezionati.map(p => p.ID_PROGETTO);
			if (this.arraySelezionati.length === 0) {
				utils.alert.warning("Seleziona almeno un ordine per creare task multiple.");
				return;
			}
			this.$refs.modalAllTask.creaTask(this.arraySelezionati, (this.filters.getModuloCorrente(this.$root.$route.path)).ICONA);
		},

		applyListeFilter(arr) {
			if (!this.search.LISTE.VALUE) {
				return arr;
			}
			return arr.filter(progetto => {
				if (!progetto.LISTE || !Array.isArray(progetto.LISTE)) return false;
				return progetto.LISTE.some(lista => lista.ID_LISTA == this.search.LISTE.VALUE);
			});
		},

		applyAccountFilter(arr) {
			if (!this.search.ACCOUNT.VALUE) {
				return arr;
			}
			return arr.filter(progetto => progetto.FK_ID_UTENTE == this.search.ACCOUNT.VALUE);
		},

		applyFornitoreFilter(arr) {
			if (!(this.search.FORNITORE.VALUE > 0)) return arr;
			return arr.filter(progetto => (progetto.FORNITORI || []).some(id => id == this.search.FORNITORE.VALUE));
		},

		apriNuovaRevisioneProgetto(progetto) {
			if (progetto.FLG_PUBBLICATA_REVISIONE_CORRENTE == 1) {
				utils.alert.warning('La revisione corrente è congelata. Non è possibile crearne una nuova.');
				return;
			}
			if (!this.canEditProgetto) return;
			this.progettoSelezionatoPerRevisione = progetto;
			this.$nextTick(() => {
				this.$refs.modalNuovaRevisione.apri();
			});
		},

		onRevisioneCreataProgetti() {
			this.getProgetti();
		},
	},

	watch: {
		viewMode() { this.disattivaOrdine(); }
	},

	computed: {
		// L'endpoint liste restituisce {id, text}; lo stato reale (FLG_ATTIVO) è
		// presente in arrayAllOpzioni. Si crea un nuovo array, senza mutare l'originale.
		optionsListeFiltro() {
			const attivi = new Map(
				(this.$root.arrayAllOpzioni || []).map(opzione => [
					String(opzione.ID_OPZIONE_TIPOLOGICA),
					opzione.FLG_ATTIVO
				])
			);
			return (this.optionsListeFiltroRaw || []).map(opzione => {
				const flag = attivi.get(String(opzione.id));
				return flag === undefined ? { ...opzione } : { ...opzione, FLG_ATTIVO: flag };
			});
		},

		ordineAttivo() { return this.lockOrdine != null && this.lockOrdine.MIO; },

		duplicaBloccata() { return this.lockDuplica != null && !this.lockDuplica.MIO; },

		// URL di stampa del budget senza ID_TEMPLATE: lo aggiunge ReportTemplateModal
		urlStampaBudget() {
			var idProgetto = this.progettoDaEsportare ? this.progettoDaEsportare.ID_PROGETTO : 0;
			return "theb/report?ID_REPORT=1006&FK_ID_PROGETTO=" + idProgetto + "&LANG=" + this.$root.currentLang;
		},

		// ==== GESTIONE PERMESSI ====

		canCreateProgetto() {
			return this.$root.isGod || utils.permissions.hasFunzionalita('PROGETTO_CREATE');
		},

		canEditProgetto() {
			return this.$root.isGod || utils.permissions.hasFunzionalita('PROGETTO_UPDATE');
		},

		canDeleteProgetto() {
			return this.$root.isGod || utils.permissions.hasFunzionalita('PROGETTO_DELETE');
		},

		canViewProgetti() {
			return this.$root.isGod || utils.permissions.hasFunzionalita('PROGETTO_READ');
		},

		canExportProgetto() {
			return this.$root.isGod || utils.permissions.hasFunzionalita('PROGETTO_EXPORT');
		},

		// ==== FINE GESTIONE PERMESSI ====

		// Filtrati senza paginazione: base per griglia e totali
		progettiFiltrati() {
			var searchFiltrata = { ...this.search };
			delete searchFiltrata.LISTE;
			delete searchFiltrata.ACCOUNT;
			delete searchFiltrata.FORNITORE;
			var arrayFiltrato = this.applyListeFilter(this.arrayProgetti);
			arrayFiltrato = this.applyAccountFilter(arrayFiltrato);
			arrayFiltrato = this.applyFornitoreFilter(arrayFiltrato);
			return utils.filter(arrayFiltrato, searchFiltrata);
		},

		baseFilteredProgetti() {
			return utils.inGrid(this.progettiFiltrati, { PAGINATION: this.search.PAGINATION }, this.ordinamento);
		},

		// Array filtrato senza paginazione (per Kanban e altre viste)
		filteredProgetti() {
			return this.baseFilteredProgetti.arr;
		},

		paginatedList() {
			return this.baseFilteredProgetti;
		},

		paginatedListStorico() {
			return utils.inGrid(this.progettoSelezionato.storico || [], this.searchStorico);
		},


		getTotali() {
			var attive = 0;
			var inattive = 0;
			var budget = 0;
			var fee = 0;
			var imponibile = 0;
			var costoEsposto = 0;
			var costoPrivato = 0;
			var margine = 0;
			for (var i = 0; i < this.progettiFiltrati.length; i++) {
				var progetto = this.progettiFiltrati[i];
				// FK_ID_STATO: riferimento a SHARED_OPZIONI_TIPOLOGICHE (ID_TIPOLOGIA = 58)
				if (progetto.FK_ID_STATO != 0) {
					attive++;
				} else {
					inattive++;
				}

				// Somma dei totali dei progetti attivi, calcolati dal backend come in Attivita.vue (Progetto::getTotaliProgetto)
				if (progetto.FLG_ATTIVO == 1 && progetto.TOTALI) {
					budget += parseFloat(progetto.TOTALI.PARZIALE) || 0;
					fee += parseFloat(progetto.TOTALI.FEE) || 0;
					imponibile += parseFloat(progetto.TOTALI.TOTALE_FINALE) || 0;
					costoEsposto += parseFloat(progetto.TOTALI.ACQUISTO) || 0;
					costoPrivato += parseFloat(progetto.TOTALI.COMMISSIONI) || 0;
					margine += parseFloat(progetto.TOTALI.MARGINE) || 0;
				}
			}

			return {
				COUNT: this.progettiFiltrati.length,
				ADVOK: attive,
				ADVKO: inattive,
				BUDGET: budget.toFixed(2),
				COSTO_ESPOSTO: costoEsposto.toFixed(2),
				COSTO_PRIVATO: costoPrivato.toFixed(2),
				FEE: fee.toFixed(2),
				GRAND_TOTAL: imponibile.toFixed(2),
				MARGINE: margine.toFixed(2)
			}
		},

		kanbanColumnWidth() {
			if (this.windowWidth < 576) return '85vw';
			if (this.windowWidth < 768) return '60vw';
			const numStati = this.arrayStatiProgetto.length;
			if (numStati == 4) {
				return 'calc(100% / 4 - 0.5rem)';
			} else if (numStati == 5) {
				return 'calc(100% / 5 - 0.5rem)';
			} else {
				return '320px';
			}
		},

	},

	created: function () {
		global.utils.BASE_API = process.env.VUE_APP_API_URL;
		this.GLOBAL_IMAGES_PATH = process.env.VUE_APP_GLOBAL_IMAGES_PATH;
		this.arrayEntiSelect2 = new Array();
		for (var i = 0; i < this.$root.arrayEnti.length; i++) {
			this.arrayEntiSelect2.push({ id: this.$root.arrayEnti[i].ID_ENTE, text: this.$root.arrayEnti[i].LABEL, })
		}
		this.progettoCorrente = utils.clone(this.$root.Progetto);
		//this.caricaModalitaEsportazione();
		// Se non è god, imposta il filtro FLG_ATTIVO a 1
		if (!this.$root.isGod) {
			this.search.FLG_ATTIVO.VALUE = '1';
		}
		utils.get('theb-s2/amministratori', { q: '' }, (response) => {
			if (response.esito == 0) this.optionsAmministratoriFiltro = response.data;
		});
		utils.get('theb-s2/liste-progetto', { q: '' }, (response) => {
			if (response.esito == 0) this.optionsListeFiltroRaw = response.data || [];
		});
		this.startUp();
	},

	mounted() {
		this._resizeHandler = () => { this.windowWidth = window.innerWidth; };
		window.addEventListener('resize', this._resizeHandler);
		document.getElementById('popUpDuplicaProgetto' + this.rs)?.addEventListener('hidden.bs.modal', (e) => { if (e.target.id == 'popUpDuplicaProgetto' + this.rs) this.rilasciaLockDuplica(); });
	},

	beforeUnmount() {
		window.removeEventListener('resize', this._resizeHandler);
		this.rilasciaLockDuplica();
		this.disattivaOrdine();
		if (this._kanbanTouchScrollHandler) {
			document.removeEventListener('touchmove', this._kanbanTouchScrollHandler);
			clearInterval(this._kanbanScrollTimer);
		}
	},

	updated() {
		setTimeout(() => {
			utils.initTooltips();
		}, 100);
	}


}
</script>

<style scoped>
	.avatar-group{display: flex;align-items: center;flex-wrap: nowrap}
	.avatar-group-item{position: relative;display: inline-block;flex-shrink: 0;margin-left: -8px;border: 2px solid rgba(var(--secondary-rgb), 0.4);border-radius: 50%;overflow: hidden;transition: transform 0.15s ease;z-index: 0}
	.avatar-group .avatar-group-item:first-child{margin-left: 0}
	.avatar-am{margin-left: 0}
	.avatar-group-item:hover{transform: scale(1.2);z-index: 10}
	.avatar-xxs{width: 25px;height: 25px;display: block;object-fit: cover}
	.storico-timeline{position: relative;padding-left: 2.25rem}
	.storico-timeline::before{content: '';position: absolute;left: 0.8rem;top: 0;bottom: 0;width: 2px;background: #e2e8f0}
	.storico-giorno{font-size: 0.75rem;font-weight: 600;text-transform: uppercase;color: #64748b;margin: 1rem 0 0.5rem}
	.storico-giorno:first-child{margin-top: 0}
	.storico-voce{position: relative;margin-bottom: 0.5rem}
	.storico-pallino{position: absolute;left: -2.25rem;top: 0.35rem;width: 1.7rem;height: 1.7rem;border-radius: 50%;display: flex;align-items: center;justify-content: center;color: #fff;font-size: 0.7rem;box-shadow: 0 0 0 3px #fff}
	.storico-riga{display: flex;align-items: center;gap: 0.75rem;padding: 0.5rem 0.75rem;border: 1px solid #e2e8f0;border-radius: 8px;color: inherit;text-decoration: none;transition: background 0.15s ease}
	.storico-riga:hover{background: #f8fafc}
	.storico-dettaglio{margin-top: 0.25rem;padding: 0.5rem 0.75rem;background: #f8fafc;border-radius: 8px;font-size: 0.875rem}
	.kanban-column{min-height: 100px}
	.kanban-column > div{transition: all 0.3s ease}
	.kanban-column > div:hover{box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12) !important}
	.kanban-column .card{border: 2px solid rgba(12, 131, 255, 0.2);border-radius: 8px;transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);background: #ffffff;position: relative}
	.kanban-column .card:hover{box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15) !important;border-color: rgba(12, 131, 255, 0.3) !important}
	.kanban-column .card-body{padding: 1rem}
	.kanban-column .card-body img{border-radius: 6px;box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);transition: transform 0.3s ease}
	.kanban-column .card-body img:hover{transform: scale(1.02)}
	.kanban-column .card-body .avatar-group img{border-radius: 0;box-shadow: none}
	.kanban-column .card-body h6{font-weight: 600;color: #1e293b;line-height: 1.4}
	.kanban-column .card-body h6 a{text-decoration: none;transition: color 0.2s ease}
	.kanban-column .card-body h6 a:hover{color: #3b82f6}
	.kanban-column .card-body .fs-sm{font-size: 0.875rem;color: #475569;display: flex;align-items: center;gap: 0.5rem}
	.kanban-column .card-body .text-muted{color: #64748b !important}
	.kanban-column .card-body .fs-sm i{color: #64748b;min-width: 1.25rem}
	.kanban-drag-handle{opacity: 0.4;transition: all 0.2s ease;cursor: grab;color: #94a3b8;font-size: 1.5rem}
	.kanban-drag-handle:hover{opacity: 0.8;color: #3b82f6;transform: scale(1.1)}
	.kanban-drag-handle:active{cursor: grabbing !important;opacity: 1;color: #2563eb}	
	.btn-kanban-action{display: inline-flex;align-items: center;justify-content: center;width: 32px;height: 32px;border-radius: 6px;color: #64748b;background-color: #f1f5f9;border: none;cursor: pointer;transition: all 0.2s ease;font-size: 1rem;text-decoration: none;padding: 0}
	.btn-kanban-action:hover{background-color: #3b82f6;color: white;transform: translateY(-2px);box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3)}
	.btn-kanban-action.text-success:hover{color: white !important}
	.btn-kanban-action:active{transform: translateY(0);box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2)}
	@media (max-width: 575px) {
		.kanban-container{height: 70vh !important;min-height: 0 !important}
		.kanban-col-body{max-height: calc(70vh - 50px) !important}
		.kanban-column .card-body{padding: 0.5rem !important}
		.kanban-drag-handle{font-size: 1.1rem !important}
	}
</style>
